import React, {forwardRef} from 'react';
import {Card, CardBody, CardHeader, Col, Collapse, Row,ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem, Label } from "reactstrap";
import {Button as SementicBtn, Button, Checkbox, Form, Icon, Rating,Dropdown, Message} from "semantic-ui-react";
import TxtLbl from "../../../../../../components/Input/Input/TxtLbl";
import TxtAreaLbl from "../../../../../../components/Input/TextArea/TextAreaLbl";
import DrpDwn from "../../../../../../components/Dropdown/Dropdown/DrpDwn";
import Lbl from "../../../../../../components/Label/Lbl";
import CropImageUploader from "../../../../../../components/CropImageUploader";
import FileUploader from "../../../../../../components/FileUpload/FileUpload";
import {MDBDataTable,MDBModal, MDBModalBody, MDBModalHeader} from "mdbreact";
import {DatePicker, Empty, message, TimePicker, Spin} from "antd";
import Files from "react-files";
import IntlTelInput from "react-intl-tel-input";
import Session from '../Agenda/index';
import GoogleAutoComplete from "../../../../../../components/Map/google_auto_complete/GoogleAutocomplete";
import GoogleDirectionMap from "../../../../../../components/Map/google_map/GoogleDirectionMap";
import 'react-intl-tel-input/dist/main.css';
import * as util from "../../../../../../util/Validator";
import * as EmailValidator from "email-validator";
import moment from "moment";
import * as actionCreator from "../../../../../../store/Action";
import {connect} from "react-redux";
import * as common from "../../../../../../const/Common/CommonFunc";
import "./Styles.css";
import apiConfig from '../../../../../../axios/axios_api_services';
import axios_event from '../../../../../../axios/axios_eventtag';
import Cookies from "js-cookie";
import base64 from "base-64";
import axios from "../../../../../../axios/axios_visitortag";
import swal from "sweetalert";
import are_you_sure_icon from "../../../../../../assets/img/sweet/question.svg";
import success_icon from "../../../../../../assets/img/sweet/success.svg";
import error_icon from "../../../../../../assets/img/sweet/cry.svg";
import csvFormat from '../../../../../../assets/csv/participant_list_format.csv';
import $ from "jquery";
import QRCode from 'qrcode';
import  { Redirect } from 'react-router-dom'
import ModernTimePicker from '../../../../../../components/TimePicker/index';
import { Radio } from 'semantic-ui-react'
import * as timeutils from '../../../../../../util/TimeConvertor';
import * as routeConstants from "../../../../../../const/route/Route";
import * as innerRoutes from "../../InnerRoutes/InnerRoutes";
import {PUBLIC_WEB_SIGN_IN_PAGE} from "../../../../../../const/route/Route";
import QuestionForm from "./QuestionForm";
import AddVolunteers from "../AddVolunteers";

const {RangePicker} = DatePicker;

function disabledDate(current) {
  return current < moment().subtract(1, "days").endOf("day");
}

class App extends React.Component {
  state = {
    //current-event
    current_event: {},
    //is session modal open or not
    isSessionOpen: false, isOpenAddVolunteers: false,
    //volunteers
    sub_event_volunteers: [],
    currentSession: null,
    sessions: [],
    //event

    subEventStatus: 'DRAFT',

    real_et_for_btn_validation: "",

    sub_event_id: 0,
    name: "",
    description: "",
    catogary: "",
    privacy: "",
    start_date: "",
    end_date: "",
    start_time: "",
    end_time: "",
    icon: "",
    brochure: "",
    brochureLink: "",
    brochureName: "",
    qr_code: "",
    onViewQR: false,
    image: '',
    isSpinQRGen: false,
    //sub events
    has_sub_event: true,
    isAutoOrManual: false,
    // location details
    // address: {
      addressLine1: "",
      addressLine2: "",
      addressLine3: "",
    // },
    location: {
      latitude: 6.9270786,
      longitude: 79.861243,
      address: ""
    },
    delay: false,
    location_: '',
    latLng: null,
    //organizer
    organizer_id: 0,
    organizer_name: "",
    organizer_mobile: "",
    is_valid_mobile: false,
    organizer_email: "",
    is_mail_valid: false,
    //event or sub event invitation img
    invitation_image: "",
    invitation_text: "",
    invitation_ok: false,
    file: [],
    json: [],
    errorjson: [
      // {row: 1, message: "this is error"}, {row: 5, message: "this is error"}, {row: 7, message: "this is error"}
    ],
    manualEnterdJson: [],
    participant_fname: "",
    participant_lname: "",
    participant_Phone: "",
    valid_participant_Phone: false,
    participant_contact: "",
    valid_participant_contact: false,
    //feedback questions
    feedback_Question: "",
    feedback_Question_Array: [],
    //sponsorship
    sponsor_name_array: [],
    sponsor_category_array: [],
    sponsor_name: "",
    onAddSponsorName: false,
    sponsor_image: '',
    onAddSponsorCategory: false,
    sponsor_category:"",
    sponsor_ok: false,
    selected_sponsor: "",
    selected_category: "",
    sponsor_details: [],

    event_type: 'PHYSICAL',

    broadcasting_url: null,
    broadcasting_instructions: null,

    s_visible: false,
    e_visible: false,

    mapOk: false,
    mailOk: false, is_question_form: false, subEventQuestions: []
  };
  changeAddVolunteersModal = () => {
    this.setState({
      isOpenAddVolunteers: !this.state.isOpenAddVolunteers
    });
  };
  closeAddVolunteersModal = () => {
    this.setState({isOpenAddVolunteers: false});
    if (this.state.sub_event_id !== 0) {
      this.loadAllVolunteers(this.state.sub_event_id);
    }
  };

  loadAllVolunteers = (sub_event_id) => {

    this.props.spinnerHandler(true);

    let corporateId = this.props.usr_obj.corporates[0].corporateId;

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8"),
      "Content-Type": "application/json"
    };

    axios_event.get(apiConfig.GET_SUB_EVENT_VOLUNTEERS({event_id: sub_event_id, corporateId: corporateId}), {headers: headers})
      .then(response => {
        if (response.data.success) {
          this.setState({sub_event_volunteers: response.data.content})
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) this.loadAllVolunteers(sub_event_id)
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };
  validateSubEvent = (state) => {
    this.state.name.trim() === '' ? this.props.current_event.has_sub_event ? common.notifyMessage("Please enter sub-event name") : common.notifyMessage("Please enter event name") :
      this.state.description.trim() === '' ? this.props.current_event.has_sub_event ? common.notifyMessage("Please enter sub-event description") : common.notifyMessage("Please enter event description") :
        this.state.catogary === '' ? this.props.current_event.has_sub_event ? common.notifyMessage("Please select sub-event category") : common.notifyMessage("Please select event category") :
          this.state.icon === '' ? this.props.current_event.has_sub_event ? common.notifyMessage("Please set sub-event icon") : common.notifyMessage("Please set event icon") :
              this.state.start_date === "" ? this.props.current_event.has_sub_event ? common.notifyMessage("Please set sub-event Date") : common.notifyMessage("Please set event Date") :
                this.state.end_date === "" ? this.props.current_event.has_sub_event ? common.notifyMessage("Please set sub-event Date") : common.notifyMessage("Please set event Date") :
                  this.state.start_time === "" ? this.props.current_event.has_sub_event ? common.notifyMessage("Please set sub-event start time") : common.notifyMessage("Please set event start time"):
                    this.state.end_time === "" ? this.props.current_event.has_sub_event ? common.notifyMessage("Please set sub-event end time") : common.notifyMessage("Please set event end time") :
                      // ((this.state.event_type === 'ONLINE' || this.state.event_type === 'BOTH') && !util.validateIsUrl(this.state.broadcasting_url))?common.notifyMessage("Please enter valid broadcasting URL"):
                        ((this.state.event_type === 'PHYSICAL' || this.state.event_type === 'BOTH') && (this.state.addressLine1 === "" || this.state.addressLine1 === "" || this.state.addressLine1 === "")) ? this.props.current_event.has_sub_event ? common.notifyMessage("Please set address of sub-event location") : common.notifyMessage("Please set address of event location") :
                          ((this.state.event_type === 'PHYSICAL' || this.state.event_type === 'BOTH') && (!this.state.mapOk)) ? common.notifyMessage("Please set location on map by searching or by drag location") :

                            (new Date(this.state.start_date)>new Date(this.state.end_date))?common.notifyMessage("Event start date can't greater than event end date") :

                            ((new Date(this.state.start_date).getFullYear() === new Date(this.state.end_date).getFullYear() &&
                              new Date(this.state.start_date).getMonth() === new Date(this.state.end_date).getMonth() &&
                              new Date(this.state.start_date).getDate() === new Date(this.state.end_date).getDate()) &&
                              (this.state.start_time >= this.state.end_time)) ? common.notifyMessage("End time can't br greater than start time also, start time & end time can't " +
                              "be same in same start date and end date") :
                          this.props.current_event.has_sub_event ?
                            this.createUpdateRedirect(state) :
                            this.validateOrganizer(state);
  };


  validateOrganizer = (state) => {
    this.state.organizer_name.trim() === '' ? common.notifyMessage("Please enter organizer name") :
      this.state.organizer_mobile.trim() === '' ? common.notifyMessage("Please enter organizer contact") :
        !this.state.is_valid_mobile ? common.notifyMessage("Please enter valid organizer contact") :
          this.state.organizer_email.trim() === '' ? common.notifyMessage("Please enter organizer email") :
            !this.state.is_mail_valid ? common.notifyMessage("Please enter valid organizer email") :
              this.createUpdateRedirect(state);
  };

  createUpdateRedirect = (state) => {

    switch (state) {
      case 1:
        this.newEventSendToBackEnd();
        break;

      case 2:
        this.updateSubEventSendBack();
        break;

      default:
        break;
    }
  };

  newEventSendToBackEnd = () => {
    let s = this.props.current_event.has_sub_event ? "Are you sure to create this sub event (" + this.state.name + ")?" :
      "Are you sure to update this event (" + this.state.name + ")?";
    swal({
      title: s,
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      buttons: {
        cancel: 'Cancel',
        dangerMode: {
          text: "Ok",
          value: "action",
          className: "okay-btn"
        }
      },
    }).then((value) => {
      switch (value) {
        case "action":
          this.newEventSendToBackEnd_();
          break;
        default:
          break;
      }
    });
  };

  updateSubEventSendBack = () => {
    swal({
      title: "Are you sure to update this event?",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      buttons: {
        cancel: 'Cancel',
        dangerMode: {
          text: "Ok",
          value: "action",
          className: "okay-btn"
        }
      },
    }).then((value) => {
      switch (value) {
        case "action":
          this.updateSubEventSendBack_();
          break;
        default:
          break;
      }
    });
  };

  newEventSendToBackEnd_ = () => {

    let addr = null;

    if(this.state.event_type !== "ONLINE") {

      let a1 = this.state.addressLine1;
      let a2 = this.state.addressLine2;
      let a3 = this.state.addressLine3;

      if(this.state.addressLine1!=="" && this.state.addressLine1!==null&&this.state.addressLine1!==undefined) {
        if(this.state.addressLine1.trim()[this.state.addressLine1.trim().length-1]===",") {
          a1 = a1.slice(0, -1);
        }
      }
      if(this.state.addressLine2!=="" && this.state.addressLine2!==null&&this.state.addressLine2!==undefined) {
        if(this.state.addressLine2.trim()[this.state.addressLine2.trim().length-1]===",") {
          a2 = a2.slice(0, -1);
        }
      }
      if(this.state.addressLine3!=="" && this.state.addressLine3!==null&&this.state.addressLine3!==undefined) {
        if (this.state.addressLine3.trim()[this.state.addressLine3.trim().length - 1] === ",") {
          a3 = a3.slice(0, -1);
        }
      }
      addr = a1+","+a2+","+a3;
    };


    let obj = {
      sub_event_id: this.state.sub_event_id,
      name: this.state.name,
      description: this.state.description,
      category_id: this.state.catogary,
      privacy: this.state.privacy,
      start_time: timeutils.YYYYMMDDHHMMSSLocalToUTCDateTime(this.state.start_date + " " + this.state.start_time),
      end_time: timeutils.YYYYMMDDHHMMSSLocalToUTCDateTime(this.state.end_date + " " + this.state.end_time),
      icon: this.state.icon,
      brochure: typeof this.state.brochure === 'string' ? this.state.brochure === ''?null:this.state.brochure : null,
      qr_code: this.state.qr_code,
      invitation_image: this.state.invitation_image,
      invitation_text: this.state.invitation_text,
      is_sub_event: this.props.current_event.has_sub_event,
      auto_approved: !this.state.isAutoOrManual,
      location_name: addr,
      longitude: this.state.event_type === "ONLINE"?null:this.state.location.longitude,
      latitude: this.state.event_type === "ONLINE"?null:this.state.location.latitude,
      eventType: this.state.event_type,
      meetingLink: null,
      meetingInstruction: this.state.event_type === "PHYSICAL"?null:this.state.broadcasting_instructions===""?null:this.state.broadcasting_instructions,
      hasQuestionsForParticipants: this.state.is_question_form,
      event_contact_list: [
        {
          event_contact_id: this.state.organizer_id,
          name: this.state.organizer_name,
          email: this.state.organizer_email,
          contact: this.state.organizer_mobile
        }
      ]
    };

    this.props.spinnerHandler(true);

    let corporateId = this.props.usr_obj.corporates[0].corporateId;

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8"),
      "Content-Type": "application/json"
    };

    //this.props.current_event.event_id
    axios_event.post(apiConfig.CREATE_SUB_EVENT({eventId: this.props.current_event.event_id, corporateId: corporateId})
      , obj, {headers: headers})
      .then(response => {
        if (response.data.success) {
          let content = response.data.content;
          this.setState({sub_event_id: content.sub_event_id });
          if (typeof this.state.brochure === 'string') {
            this.props.current_event.has_sub_event ?
            common.warningAlert("Event created successfully!", 0) : common.warningAlert("Event updated successfully!", 0);
            this.refreshData(content);
          } else {
            this.sendBrochureToBackEnd(content.sub_event_id, content, 1);
          }

        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.newEventSendToBackEnd_()
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });


  };

  updateSubEventSendBack_ = () => {

    let addr = null;

    if(this.state.event_type !== "ONLINE") {

      let a1 = this.state.addressLine1;
      let a2 = this.state.addressLine2;
      let a3 = this.state.addressLine3;

      if(this.state.addressLine1!=="" && this.state.addressLine1!==null&&this.state.addressLine1!==undefined) {
        if (this.state.addressLine1.trim()[this.state.addressLine1.trim().length - 1].trim() === ",") {
          a1 = a1.slice(0, -1);
        }
      }
      if(this.state.addressLine2!=="" && this.state.addressLine2!==null&&this.state.addressLine2!==undefined) {
        if (this.state.addressLine2.trim()[this.state.addressLine2.trim().length - 1].trim() === ",") {
          a2 = a2.slice(0, -1);
        }
      }
      if(this.state.addressLine3!=="" && this.state.addressLine3!==null&&this.state.addressLine3!==undefined) {
        if (this.state.addressLine3.trim()[this.state.addressLine3.trim().length - 1].trim() === ",") {
          a3 = a3.slice(0, -1);
        }
      }
      addr = a1+","+a2+","+a3;
    };

    let obj = {
      sub_event_id: this.state.sub_event_id,
      name: this.state.name,
      description: this.state.description,
      category_id: this.state.catogary,
      privacy: this.state.privacy,
      start_time: timeutils.YYYYMMDDHHMMSSLocalToUTCDateTime(this.state.start_date + " " + this.state.start_time),
      end_time: timeutils.YYYYMMDDHHMMSSLocalToUTCDateTime(this.state.end_date + " " + this.state.end_time),
      icon: this.state.icon,
      brochure: typeof this.state.brochure === 'string'? this.state.brochure===''?null:this.state.brochure : null,
      qr_code: this.state.qr_code,
      invitation_image: this.state.invitation_image,
      invitation_text: this.state.invitation_text,
      is_sub_event: this.props.current_event.has_sub_event?true:false,
      auto_approved: !this.state.isAutoOrManual,
      // is_sub_event: true,
      location_name: addr,
      longitude: this.state.event_type === "ONLINE"?null:this.state.location.longitude,
      latitude: this.state.event_type === "ONLINE"?null:this.state.location.latitude,
      status: this.state.subEventStatus,
      eventType: this.state.event_type,
      meetingLink: null,
      meetingInstruction: this.state.event_type === "PHYSICAL"?null:this.state.broadcasting_instructions===""?null:this.state.broadcasting_instructions,
      hasQuestionsForParticipants: this.state.is_question_form,
      event_contact_list: [
        {
          event_contact_id: this.state.organizer_id,
          name: this.state.organizer_name,
          email: this.state.organizer_email,
          contact: this.state.organizer_mobile
        }
      ]
    };

    this.props.spinnerHandler(true);

    let corporateId = this.props.usr_obj.corporates[0].corporateId;

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8"),
      "Content-Type": "application/json"
    };

    axios_event.patch(apiConfig.UPDATE_SUB_EVENT({corporateId: corporateId}), obj, {headers: headers})
      .then(response => {
        if (response.data.success) {

          let content = response.data.content;
          if (typeof this.state.brochure === 'string') {
            this.props.current_event.has_sub_event ?
              common.warningAlert("Sub event updated successfully!", 0) : common.warningAlert("Event updated successfully!", 0);
            this.refreshData(content);
          } else {
            this.sendBrochureToBackEnd(response.data.content.sub_event_id, content, 2);
          }
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.updateSubEventSendBack_()
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });

  };

  sendBrochureToBackEnd = (sub_event_id, content, state) => {

    let message = "created";

    if (state === 2) {
      message = "updated";
    }

    if(this.state.brochure!==undefined && this.state.brochure!==null && this.state.brochure!=="") {

      this.props.spinnerHandler(true);

      let file_upload_state = false;
      let catch_error = false;
      let brochureUrl = null;

      let formData = new FormData();
      formData.append('id', sub_event_id);
      formData.append('file', this.state.brochure);
      formData.append('type', 'SUB_EVENT_BROCHURE_PDF');

      let corporateId = this.props.usr_obj.corporates[0].corporateId;

      const headers = {
        "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8"),
        'content-type': 'multipart/form-data'
      };
      axios_event.put(apiConfig.SEND_BROCHURE_FILES({corporateId: corporateId}), formData, {headers: headers})
        .then(response => {
          if (response.data.success) {
            file_upload_state = true;
            catch_error = false;
            content.brochure = response.data.url;
            this.refreshData(content);
          } else {

            common.warningAlert(response.data.message, 1);
            file_upload_state = false;
            catch_error = false;

          }
        })
        .catch(async error => {
          let result = await common.checkErrorResponse(error);
          if (result === 1) {
            this.sendBrochureToBackEnd(sub_event_id, content, state)
          } else {
            file_upload_state = false;
            catch_error = true;
          }
        })
        .finally(fin => {
          this.props.spinnerHandler(false);
          if (file_upload_state) {

            swal({
              title: "The event " + message + " successfully!",
              icon: success_icon,
              closeOnClickOutside: false,
              buttons: {
                dangerMode: {
                  text: "Okay",
                  value: "action",
                  className: "okay-btn"
                }
              }
            })
              .then((value) => {
                switch (value) {

                  case "action":
                    break;
                  default:
                }
              });

          } else {
            if (catch_error) {
              swal({
                title: "The event " + message + " successfully! But, the Brochure upload failed.\"",
                icon: success_icon,
                closeOnClickOutside: false,
                buttons: {
                  dangerMode: {
                    text: "Okay",
                    value: "action",
                    className: "okay-btn"
                  }
                }
              })
                .then((value) => {
                  switch (value) {
                    case "action":
                      break;
                    default:
                  }
                });

            } else {
              swal({
                title: "The event " + message + " successfully! But, the Brochure upload failed.\"",
                icon: error_icon,
                closeOnClickOutside: false,
                buttons: {
                  dangerMode: {
                    text: "Okay",
                    value: "action",
                    className: "okay-btn"
                  }
                }
              })
                .then((value) => {
                  switch (value) {
                    case "action":
                      break;
                    default:
                  }
                });
            }
          }
        });

      this.refreshData(content);

    } else {
      this.refreshData(content);
      swal({
        title: "The event " + message + " successfully!",
        icon: success_icon,
        closeOnClickOutside: false,
        buttons: {
          dangerMode: {
            text: "Okay",
            value: "action",
            className: "okay-btn"
          }
        }
      })
        .then((value) => {
          switch (value) {

            case "action":
              break;
            default:
          }
        });
    }

  };
  //------- refresh --------
  refreshData = (content) => {
    // let event_id = response.data.event_id;
    let has_s_e = this.props.current_event.has_sub_event;
    let start_date = "";
    let start_time = "";

    let end_date = "";
    let end_time = "";

    if (content.start_time !== "" && content.end_time !== "") {
      let startDatetTimeArray = (timeutils.YYYYMMDDHHMMSSUTCToLocalDateTime(content.start_time)).split(" ");
      start_date = startDatetTimeArray[0];
      start_time = startDatetTimeArray[1];
      let endDatetTimeArray = (timeutils.YYYYMMDDHHMMSSUTCToLocalDateTime(content.end_time)).split(" ");
      end_date = endDatetTimeArray[0];
      end_time = endDatetTimeArray[1];
    }

    let organizer_id = "";
    let organizer_name = "";
    let organizer_mobile = "";
    let organizer_email = "";

    if (content.event_contact_list !== null) {
      organizer_id = content.event_contact_list[0].event_contact_id;
      organizer_name = content.event_contact_list[0].name;
      organizer_mobile = content.event_contact_list[0].contact;
      organizer_email = content.event_contact_list[0].email;
    }

    let loc = {
      latitude: 6.9270786,
      longitude: 79.861243,
      address: "",
    };

    if(content.eventType !== "ONLINE") {
      loc = {
        latitude: parseFloat(content.longitude),
        longitude: parseFloat(content.longitude),
        address: "",
      };
    }


    let address1 = "";
    let address2 = "";
    let address3 = "";

    if(content.eventType !== "ONLINE") {
      if (content.location_name !== null && content.location_name !== undefined) {
        let strings = content.location_name.split(",");
        if (strings.length > 1) {
          if (strings.length === 1) {
            address1 = strings[strings.length - 1];
          } else if (strings.length === 2) {
            address2 = strings[strings.length - 1];
            address1 = strings[strings.length - 2];
          } else {
            address3 = strings[strings.length - 1];
            address2 = strings[strings.length - 2];
            if (strings.length > 3) {
              let add3 = "";
              for (let i = (strings.length - 3); i > -1; i--) {
                add3 = strings[i] + "," + add3;
              }
              address1 = add3;
            } else {
              address1 = strings[strings.length - 3]
            }
          }
        }
      }
    }

    this.setState({
      sub_event_id: content.sub_event_id,
      name: content.name,
      description: content.description,
      catogary: content.category_id,
      privacy: content.privacy,
      start_date: start_date,
      end_date: end_date,
      start_time: start_time,
      end_time: end_time,
      icon: content.icon,
      qr_code: content.qr_code,
      brochure: content.brochure !== null ? content.brochure : "",
      brochureLink: content.brochure !== null ? content.brochure : "",
      brochureName: "",
      //sub events
      has_sub_event: has_s_e,
      // location details
      // address: content.location_name,



      addressLine1: address1,
      addressLine2: address2,
      addressLine3: address3,

      location: loc,
      delay: false,
      location_: '',
      latLng: null,
      //organizer
      organizer_id: organizer_id,
      organizer_name: organizer_name,
      organizer_mobile: organizer_mobile,
      is_valid_mobile: true,
      organizer_email: organizer_email,
      is_mail_valid: true,

      eventType: content.eventType,
      broadcasting_url: (content.eventType === "ONLINE" || content.eventType === "BOTH")?(content.hostUrl === null || content.hostUrl === undefined)?"":content.hostUrl:"",
      broadcasting_instructions: (content.meetingInstruction === null || content.meetingInstruction === undefined)?"":content.meetingInstruction,
    });
  }
  onchangeHandler = name => event => {
    let value = event.target.value;
    switch (name) {
      case 'name':
        this.setState({name: value});
        break;
      case 'description':
        this.setState({description: value});
        break;
      case 'organizer_name':
        this.setState({organizer_name: value});
        break;
      case 'organizer_mobile':
        let onlyDigit = new RegExp("^\\d+$");
        if (onlyDigit.test(value) || value.length === 0) {
          let isValidMobile = util.mobileNumValidator(value, "ALL", 1);
          if (isValidMobile) {
            this.setState({
              is_valid_mobile: true,
              organizer_mobile: value
            });
          } else {
            this.setState({
              is_valid_mobile: false,
              organizer_mobile: value
            });
          }
        }
        break;
      case 'organizer_email':
        let validateEmail = EmailValidator.validate(value);
        if (validateEmail) {
          this.setState({
            organizer_email: value,
            is_mail_valid: true
          });
        } else {
          this.setState({
            organizer_email: value,
            is_mail_valid: false
          });
        }
        break;
      case 'bcurl':
        this.setState({
          broadcasting_url: value
        });
        break;
      case 'bci':
        this.setState({
          broadcasting_instructions: value
        });
        break;
      default:
        break;
    }

  };
  sponsorNameChangehandler = (e, {value}) => {
    this.setState({
      selected_sponsor: value
    });
  };
  sponsorCategoryChangehandler = (e, {value}) => {
    this.setState({
      selected_category: value
    });
  };
  //-------------------------
  catogaryChangehandler = (e, {value}) => {
    this.setState({
      catogary: value
    });
  };
  //------- refreash --------
  privacyChangeHandler = () => {
    let value = (this.state.privacy === "PUBLIC") ? "PRIVATE" : "PUBLIC";
    this.setState({
      privacy: value
    });

  };
  hasSubEventChangeHandler = () => {
    this.setState({
      has_sub_event: !this.state.has_sub_event
    });

  };
  setIcon = (image, convert) => {
    this.setState({
      icon: convert
    });

  };
  setBrochure = (file, fileName, base64) => {
    this.setState({
      brochure: file,
      brochureLink: base64,
      brochureName: fileName
    });

  };

  onFilesError = () => {
    console.log("onFilesError")
  };
  startTimeOnChange = (time, timeString) => {
    this.setState({
      start_time: timeString + ":00",
    });

  };
  endTimeOnChange = (time, timeString) => {
    this.setState({
      end_time: timeString + ":00",
    });

  };
  dateRangeOnChange = (date, dateString) => {
    if (dateString[0] !== "" || dateString[1] !== "") {
      let start = new Date(dateString[0]);
      let end = new Date(dateString[1]);
      start = (start.toISOString()).split("T")[0];
      end = (end.toISOString()).split("T")[0];
      this.setState({
        start_date: start,
        end_date: end
      });
    }

  };

  //$#$#
  dateOnChangeStart = (date, dateString) => {
    if (dateString !== null) {
      let start = new Date(dateString);
      this.setState({
        start_date: dateString,
      });
    }
  };
  dateOnChangeEnd = (date, dateString) => {
    if (dateString !== null) {
      let end = new Date(dateString);
      this.setState({
        end_date: dateString,
      });
    }
  };
  //$#$#

  changeSessionModal = () => {
    if (this.state.start_date === "" || this.state.end_date === "" || this.state.start_time === "" || this.state.end_time === "" || this.state.sub_event_id === 0) {
      common.notifyMessage("Please set start date, end date, start time, end time and location before create new session")
    } else {
      this.setState({
        currentSession: null,
        isSessionOpen: !this.state.isSessionOpen
      });
    }
  };
  onPhoneNumberChange = e => {
    let value = e.target.value;

    let regex = new RegExp('[^0-9]');

    let valid = false;
    if (value.length >= 9 && value.length <= 10) {
      if(!regex.test(value)) {
        valid = true;
      }
    }
    if(value.length<11) {
      this.setState({
        organizer_mobile: value,
        is_valid_mobile: valid
      });
    }

  };
  setLocation = (obj) => {
    this.setState({delay: true});
    this.setState({
      location: {
        latitude: obj.latitude,
        longitude: obj.longitude,
        address: obj.address,
        // icon: markerIcon,
      },
      mapOk: true,
      delay: false
    });
  };

  updateMapLocation = (obj) => {
    this.setState({
      location: obj,
      mapOk: true
    });
    this.forceUpdate();

  };
  setAddressOfLocation = name => e => {

    let value = e.target.value;

      switch (name) {
        case "address1":
          this.setState({
              addressLine1: value,
          });
          break;
        case "address2":
          this.setState({
              addressLine2: value,
          });
          break;
        case "address3":
          this.setState({
              addressLine3: value
          });
          break;
        default:
          break;
    };

  };
  fillDataAsEvent = (main, sub_event) => {
    // let pri = main.privacy;
    if (sub_event === undefined || sub_event.length === 0) {
      this.setState({
        event_id:main.event_id,
        name: main.event_name,
        description: main.description,
        catogary: main.category_id,
        privacy: main.privacy,
        has_sub_event: main.has_sub_event,
        icon: main.icon !== null ? main.icon : "",
        brochure: main.brochure !== null ? main.brochure : "",
        brochureLink: main.brochure !== null ? main.brochure : "",
        brochureName: "",
        organizer_id: main.event_contact_list[0].event_contact_id,
        organizer_name: main.event_contact_list[0].name,
        organizer_mobile: main.event_contact_list[0].contact,
        is_valid_mobile: true,
        organizer_email: main.event_contact_list[0].email,
        is_mail_valid: true,
        mapOk: false,
        mailOk: false,
      });
    } else {
      let start_date = "";
      let start_time = "";
      let end_date = "";
      let end_time = "";

      let real_et_for_btn_validation = "";

      if (sub_event[0].start_time !== "" && sub_event[0].end_time !== "") {

        real_et_for_btn_validation = timeutils.YYYYMMDDHHMMSSUTCToLocalDateTime(sub_event[0].end_time);

        let startDatetTimeArray = (timeutils.YYYYMMDDHHMMSSUTCToLocalDateTime(sub_event[0].start_time)).split(" ");
        start_date = startDatetTimeArray[0];
        start_time = startDatetTimeArray[1];

        let endDatetTimeArray = (timeutils.YYYYMMDDHHMMSSUTCToLocalDateTime(sub_event[0].end_time)).split(" ");
        end_date = endDatetTimeArray[0];
        end_time = endDatetTimeArray[1];

        sub_event = sub_event[0];

        let loc = {
          latitude: 6.9270786,
          longitude: 79.861243,
          address: "",
        };

        if(sub_event.eventType !== "ONLINE") {
          loc = {
            latitude: parseFloat(sub_event.latitude),
            longitude: parseFloat(sub_event.longitude),
            address: "",
          };
        }

        let address1 = "";
        let address2 = "";
        let address3 = "";
        if(sub_event.location_name !== null && sub_event.location_name !== undefined) {

          let strings = sub_event.location_name.split(",");
          if(strings.length>1) {
            if(strings.length === 1) {
              address1 = strings[strings.length-1];
            } else if(strings.length === 2) {
              address2 = strings[strings.length-1];
              address1 = strings[strings.length-2];
            } else {
              address3 = strings[strings.length-1];
              address2 = strings[strings.length-2];
              if(strings.length>3) {
                let add3 = "";
                for(let i = (strings.length-3); i>-1; i--) {
                  add3 = strings[i] + "," + add3;
                }
                address1 = add3;
              } else {
                address1 = strings[strings.length-3]
              }
            }
          }

          // address1 = sub_event.location_name.split(",", 1) !== undefined ? sub_event.location_name.split(",", 1) : "";
          // address2 = sub_event.location_name.split(",", 2).pop(1) !== undefined ?
          //   sub_event.location_name.split(",", 2).pop(1) : "";
          // address3 = sub_event.location_name.split(",", 3).pop(2) !== undefined ?
          //   sub_event.location_name.split(",", 3).pop(2) : "";

        }

        this.setState({
          real_et_for_btn_validation: real_et_for_btn_validation,
          // sub_event_id: ,
          subEventStatus: sub_event.status,
          sub_event_id: sub_event.sub_event_id,
          name: sub_event.name,
          description: sub_event.description,
          catogary: sub_event.category_id,
          privacy: main.privacy,
          has_sub_event: main.has_sub_event,
          isAutoOrManual: !sub_event.auto_approved,
          start_date: start_date,
          end_date: end_date,
          start_time: start_time,
          end_time: end_time,
          icon: main.icon !== null ? main.icon : "",
          qr_code: sub_event.qr_code,
          // address: sub_event.location_name,
          addressLine1: address1,
          addressLine2: address2,
          addressLine3: address3,
          brochure: main.brochure !== null ? main.brochure : "",
          brochureLink: main.brochure !== null ? main.brochure : "",
          brochureName: "",
          organizer_id: main.event_contact_list[0].event_contact_id,
          organizer_name: main.event_contact_list[0].name,
          organizer_mobile: main.event_contact_list[0].contact,
          is_valid_mobile: true,
          organizer_email: main.event_contact_list[0].email,
          is_mail_valid: true,
          invitation_image: sub_event.invitation_image !== null ? sub_event.invitation_image : "",
          invitation_text: sub_event.invitation_text !== null ? sub_event.invitation_text : "",
          invitation_ok: (sub_event.invitation_image !== null & sub_event.invitation_text !== null) ? true : false,
          location: loc,
          // sponsor_name_ok: (sub_event.sponsor_image !== null & sub_event.sponsor_name !== null) ? true : false,
          // sponsor_category_ok: sub_event.sponsor_category !== null ? true: false
          event_type: (sub_event.eventType === "" || sub_event.eventType === null || sub_event.eventType === undefined)?"PHYSICAL":sub_event.eventType,
          broadcasting_url: (sub_event.eventType === "ONLINE" || sub_event.eventType === "BOTH")?sub_event.hostUrl:"",
          broadcasting_instructions: (sub_event.meetingInstruction === null || sub_event.meetingInstruction === undefined)?"":sub_event.meetingInstruction,
          mapOk: sub_event.eventType !== "ONLINE"?true:false,
          is_question_form: sub_event.hasQuestionsForParticipants,
          subEventQuestions: sub_event.subEventQuestions
        });
        this.loadAllSessions(sub_event.sub_event_id);
        this.loadFeedbackQuestions(sub_event.sub_event_id);
        this.loadAllSponsorNames(sub_event.sub_event_id);
        this.loadAllSponsorCategories(sub_event.sub_event_id);
        this.loadAllVolunteers(sub_event.sub_event_id);
        this.loadAllSponsorDetails(sub_event.sub_event_id);
      }
    }
  };
  fillDataAsSubEvent = (main, sub_id) => {

    // NOTE : when create new sub event then sub_id come as empty string
    if (sub_id !== '') {

      let sub_e = this.props.current_sub_events[sub_id];

      let sub_event_id = sub_e.sub_event_id;
      let qr = sub_e.qr_code;

      let start_date = "";
      let start_time = "";

      let end_date = "";
      let end_time = "";

      let real_et_for_btn_validation = "";

      if (sub_e.start_time !== "" && sub_e.end_time !== "") {

        real_et_for_btn_validation = timeutils.YYYYMMDDHHMMSSUTCToLocalDateTime(sub_e.end_time);

        let startDatetTimeArray = (timeutils.YYYYMMDDHHMMSSUTCToLocalDateTime(sub_e.start_time)).split(" ");
        start_date = startDatetTimeArray[0];
        start_time = startDatetTimeArray[1];

        let endDatetTimeArray = (timeutils.YYYYMMDDHHMMSSUTCToLocalDateTime(sub_e.end_time)).split(" ");
        end_date = endDatetTimeArray[0];
        end_time = endDatetTimeArray[1];
      }

      let loc = {
        latitude: 6.9270786,
        longitude: 79.861243,
        address: "",
      };

      if(sub_e.eventType !== "ONLINE") {
        loc = {
          latitude: parseFloat(sub_e.latitude),
          longitude: parseFloat(sub_e.longitude),
          address: sub_e.location_name ? sub_e.location_name : "-",
        };
      }

      let address1 = "";
      let address2 = "";
      let address3 = "";
      if(sub_e.location_name !== null && sub_e.location_name !== undefined) {

        let strings = sub_e.location_name.split(",");
        if(strings.length>1) {
          if(strings.length === 1) {
            address1 = strings[strings.length-1];
          } else if(strings.length === 2) {
            address2 = strings[strings.length-1];
            address1 = strings[strings.length-2];
          } else {
            address3 = strings[strings.length-1];
            address2 = strings[strings.length-2];
               if(strings.length>3) {
                 let add3 = "";
                 for(let i = (strings.length-3); i>-1; i--) {
                    add3 = strings[i] + "," + add3;
                 }
                  address1 = add3;
               } else {
                 address1 = strings[strings.length-3]
               }
          }
        }
          // address1 = sub_e.location_name.split(",", 1) !== undefined ? sub_e.location_name.split(",", 1) : "";
          // address2 = sub_e.location_name.split(",", 2).pop(1) !== undefined ?
          //   sub_e.location_name.split(",", 2).pop(1) : "";
          // address3 = sub_e.location_name.split(",", 3).pop(2) !== undefined ?
          //   sub_e.location_name.split(",", 3).pop(2) : "";

      }

      this.setState({
        isAutoOrManual: !sub_e.auto_approved,
        real_et_for_btn_validation: real_et_for_btn_validation,
        subEventStatus: sub_e.status,
        sub_event_id: sub_event_id,
        name: sub_e.name,
        description: sub_e.description,
        catogary: sub_e.category_id,
        privacy: sub_e.privacy,
        start_date: start_date,
        end_date: end_date,
        start_time: start_time,
        end_time: end_time,
        icon: sub_e.icon !== null ? sub_e.icon : "",
        qr_code: sub_e.qr_code,
        addressLine1: address1,
        addressLine2: address2,
        addressLine3: address3,
        brochure: sub_e.brochure !== null ? sub_e.brochure : "",
        brochureLink: sub_e.brochure !== null ? sub_e.brochure : "",
        brochureName: "",
        invitation_image: sub_e.invitation_image !== null ? sub_e.invitation_image : "",
        invitation_text: sub_e.invitation_text !== null ? sub_e.invitation_text : "",
        invitation_ok: (sub_e.invitation_image !== null & sub_e.invitation_text !== null) ? true : false,
        location: loc,
        mapOk: sub_e.eventType !== "ONLINE" ? true:false,
        mailOk: (sub_e.invitation_text !== null && sub_e.invitation_text !== "" && sub_e.invitation_text !== undefined) ?true:false,

        event_type: (sub_e.eventType === "" || sub_e.eventType === null || sub_e.eventType === undefined)?"PHYSICAL":sub_e.eventType,
        broadcasting_url: (sub_e.eventType === "ONLINE" || sub_e.eventType === "BOTH")?sub_e.hostUrl:"",
        broadcasting_instructions: (sub_e.meetingInstruction === null || sub_e.meetingInstruction === undefined)?"":sub_e.meetingInstruction,
        is_question_form: sub_e.hasQuestionsForParticipants,
        subEventQuestions: sub_e.subEventQuestions
      });

      this.loadAllSessions(sub_event_id);
      this.loadFeedbackQuestions(sub_event_id);
      this.loadAllSponsorNames(sub_event_id);
      this.loadAllSponsorCategories(sub_event_id);
      this.loadAllSponsorDetails(sub_event_id);
      this.loadAllVolunteers(sub_event_id);

    } else {

      this.setState({
        sub_event_id: 0,
        name: "",
        description: "",
        catogary: "",
        privacy: this.props.current_event.privacy,
        start_date: "",
        end_date: "",
        start_time: "",
        end_time: "",
        icon: "",
        brochure: "",
        // location:{
        //   latitude: sub_e.latitude,
        //   longitude: sub_e.longitude,
        //   address: sub_e.location_name,
        // }
        addressLine1: "",
        addressLine2: "",
        addressLine3: "",
        mapOk: false,
        mailOk: false,
      });
    }
  };
  loadAllSessions = (id) => {

    this.props.spinnerHandler(true);

    let corporateId = this.props.usr_obj.corporates[0].corporateId;

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    axios_event.get(apiConfig.GET_SUB_EVENT_SESSIONS({sub_event_id: id,corporateId: corporateId}), {headers: headers})
      .then(async response => {

        if (response.data.success) {
          let sessionList = response.data.sessionList;
          this.setState({
            sessions: sessionList
          });
          this.props.spinnerHandler(false);
        }

      }).catch(async error => {
      let result = await common.checkErrorResponse(error);
      if (result === 1) {
        this.loadAllSessions(id);
      } else {
        this.props.spinnerHandler(false)
      }
    });

  };
  loadFeedbackQuestions = (id) => {
    this.props.spinnerHandler(true);

    let corporateId = this.props.usr_obj.corporates[0].corporateId;

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    axios_event.get(apiConfig.MANAGE_GET_DELETE_FEED_BACK_QUESTION({id: id, corporateId: corporateId}), {headers: headers})
      .then(async response => {

        if (response.data.success) {
          let quetiondList = response.data.eventQuestion;
          this.setState({
            feedback_Question_Array: quetiondList
          });
          this.props.spinnerHandler(false);
        }

      }).catch(async error => {
      let result = await common.checkErrorResponse(error);
      if (result === 1) {
        this.loadFeedbackQuestions(id);
      } else {
        this.props.spinnerHandler(false)
      }
    });

  };
  onFilesChange = name => files => {
    !this.state.invitation_ok ? common.notifyMessage("Please set invitation image and invitation text before set invitees") :
      this.onFilesChange_(name, files);
  };
  onFilesChange_ = (name, files) => {
    if (files.length !== 0) {
      this.onFileChange(name, files[0]);
    } else {
      message.error("Please choose valid file type!");
    }
  };
  //following methods use for csv upload for participants - start
  onFileChange = async (name, e) => {
    const textDataUrl = await readFile(e);
    this.setState({
      isSpin: false,
      [name]: textDataUrl,
      // errorjson: [],
      json: this.base64Decode(textDataUrl, "SVG"),
    });

  };
  base64Decode = (bytes, file) => {
    try {
      let split = bytes.split("base64,");
      let decode = base64.decode(split[1]);
      return this.csvToJson(decode);
    } catch (e) {
      message.error("Please select " + file + " file!");
    }
  };
  csvToJson = (csv) => {
    this.setState({isSpin: true});
    let lines = csv.split("\n");
    let result = [];

    let headers = ["First Name", "Last Name", "Mobile/Email"];
    // let headers2 = ["name", "identification", "phone", "email"];
    let headers2 = ["firstName", "lastName", "contact"];
    for (let i = 1; i < lines.length; i++) {
      let obj = {};
      let currentline = lines[i].split(",");
      if (currentline.length > 1) {
        for (let j = 0; j < headers.length; j++) {
          let value1 = currentline[j];
          if (value1 === undefined) {
            value1 = "";
          }
          let value = value1.trim();
          if (value.toString() === "") {
            value = "";
          }
          obj[headers2[j]] = value;
        }
        obj["checked"] = true;
        // if (obj.hostBMobile !== undefined) {
        result.push(obj);
        // }
      }
    }
    if (result.length === 0) {
      common.notifyMessage("Empty file!")
    }
    return result;
  };

  //QR code
  onViewQR = async (uuid = null) => {
    await this.setState({onViewQR:true })
    this.generateQR(uuid);
  }

  onWEBViewQR = async (uuid = null) => {
    await this.setState({onViewQR:true})
    this.generateQR(uuid);
  }

  generateQR = (qr_code) => {
    qr_code = qr_code ? qr_code : this.state.qr_code;
    this.setState({isSpinQRGen: true});
    if(qr_code && qr_code !== ""){
      QRCode.toDataURL(qr_code.toString(),{ scale: 10 })
        .then(url => {
          this.setState({isSpinQRGen: false, image: url});
        })
        .catch(err => {
          console.error(err)
        })
    }
  };

  //sponsership handle
  loadAllSponsorNames = (id) => {
    // this.setState({
    //   sponsor_name_array: this.props.sponsor_obj.sponsorList,
    //   sponsor_category_array: this.props.sponsor_obj.sponsorCatList
    // })
    this.props.spinnerHandler(true);

    let corporateId = this.props.usr_obj.corporates[0].corporateId;

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    axios_event.get(apiConfig.GET_ALL_SPONSOR_NAMES({sub_event_id: id, corporateId: corporateId}), {headers: headers})
      .then(async response => {
        if (response.data.success) {
          this.setState({
            sponsor_name_array: response.data.content,
          });
          this.props.spinnerHandler(false);
        }

      }).catch(async error => {
      let result = await common.checkErrorResponse(error);
      if (result === 1) {
        this.loadAllSponsorNames(id);
      } else {
        this.props.spinnerHandler(false)
      }
    });
  };

  loadAllSponsorCategories = (id) => {
    // this.setState({
    //   sponsor_name_array: this.props.sponsor_obj.sponsorList,
    //   sponsor_category_array: this.props.sponsor_obj.sponsorCatList
    // })
    this.props.spinnerHandler(true);

    let corporateId = this.props.usr_obj.corporates[0].corporateId;

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    axios_event.get(apiConfig.GET_ALL_SPONSORSHIP_CATEGORY({corporateId: corporateId}), {headers: headers})
      .then(async response => {
        if (response.data.success) {
          this.setState({
            sponsor_category_array:response.data.content
          });
          this.props.spinnerHandler(false);
        }

      }).catch(async error => {
      let result = await common.checkErrorResponse(error);
      if (result === 1) {
        this.loadAllSponsorCategories(id);
      } else {
        this.props.spinnerHandler(false)
      }
    });
  };

  getAllSponsorDetails__ = () => {

    this.state.selected_sponsor === ""? common.notifyMessage("Please, select sponsor name before save sponsor"):
      this.state.selected_category === ""? common.notifyMessage("Please, select sponsor category before save sponsor"):
        this.getAllSponsorDetails();
  };

  getAllSponsorDetails = () => {
    let v = true;
    this.state.sponsor_details.map((value, index) =>{
      if(value.sponsor_id === this.state.selected_sponsor && value.sponsorship_category_id === this.state.selected_category) {
        v = false
      }
    });
    if(v) {
      this.getAllSponsorDetails_();
    } else {
      common.notifyMessage("This sponsor is already in sponsor list with same sponsor category");
    }
  };
  getAllSponsorDetails_ = () => {
    this.props.spinnerHandler(true);

    let corporateId = this.props.usr_obj.corporates[0].corporateId;

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    let req_obj = {
      sub_event_id: this.state.sub_event_id,
      sponsor_id: this.state.selected_sponsor,
      sponsorship_category_id: this.state.selected_category
    };

    axios_event.post(apiConfig.GET_SELECTED_SPONSOR_DETAILS({sub_event_id:this.state.sub_event_id, sponsor_id: this.state.selected_sponsor,
      sponsor_category_id: this.state.selected_category, corporateId: corporateId}),req_obj, {headers: headers})
      .then(async response => {
        if (response.data.success) {
          this.setState({
            sponsor_details: response.data.content
          });
          // this.state.loadAllSponsorDetails();
          this.props.spinnerHandler(false);
        }

      }).catch(async error => {
      let result = await common.checkErrorResponse(error);
      if (result === 1) {
        this.getAllSponsorDetails();
      } else {
        this.props.spinnerHandler(false)
      }
    });
  }

  loadAllSponsorDetails = (id) => {
    this.props.spinnerHandler(true)

    let corporateId = this.props.usr_obj.corporates[0].corporateId;

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    axios_event.get(apiConfig.LOAD_ALL_SPONSOR_DETAILS({sub_event_id:id, corporateId: corporateId}), {headers: headers})
      .then(async response => {
        if (response.data.success) {
          this.setState({
            sponsor_details: response.data.content
          });
          this.props.spinnerHandler(false);
        }

      }).catch(async error => {
      let result = await common.checkErrorResponse(error);
      if (result === 1) {
        this.loadAllSponsorDetails(id);
      } else {
        this.props.spinnerHandler(false)
      }
    });
  }

  onAddSponsorName = () => {
    this.setState({
      onAddSponsorName:true
    })
  };

  onAddSponsorCategory = () => {
    this.setState({
     onAddSponsorCategory: true
    })
  };

  setSponsorImage = (image, convert) => {
    this.setState({
      sponsor_image: convert
    })
  }

  setSponsorDetails = name => e => {
    let value =e.target.value;
    switch (name) {
      case "sponsorname":
        this.setState({sponsor_name: value});
        break;
      case "sponsorcategory":
        this.setState({sponsor_category: value});
        break;
      default:
        break;
    }
  }
  cleanSponsorName = () => {
    this.setState({
      sponsor_name : "",
      sponsor_image: ""
    })
  }

  cleanCategoryName = () => {
    this.setState({
      sponsor_category : "",
    })
  }

  manageSponsor = () => {
    this.state.sponsor_name === '' ? common.notifyMessage("Please enter sponsor name") :
      this.state.sponsor_image === '' ? common.notifyMessage("Please upload sponsor image") :
        this.sponsorDetailsSendToBackEnd('name');
  };

  manageSponsorCategory = () => {
    this.state.sponsor_category.trim() === '' ? common.notifyMessage("Please enter a sponsor category") :
      this.sponsorDetailsSendToBackEnd('s_category');
  }

  sponsorDetailsSendToBackEnd = (name) => {
    switch (name){
      case "name" :
        swal({
          className: "swal-reception-number-check",
          text: "Are you sure to add this sponsor?",
          icon: are_you_sure_icon,
          closeOnClickOutside: false,
          buttons: {
            cancel: 'Cancel',
            dangerMode: {
              text: "Ok",
              value: "action",
              className: "okay-btn"
            }
          },
        }).then((value) => {
          switch (value) {
            case "action":
              this.sponsorSendToBackEnd_();
              // this.loadAllSponsorNames();
              break;
            default:
              break;
          }
        });
        break;
        case "s_category" :
          swal({
            className: "swal-reception-number-check",
            text: "Are you sure to add this sponsor category?",
            icon: are_you_sure_icon,
            closeOnClickOutside: false,
            buttons: {
              cancel: 'Cancel',
              dangerMode: {
                text: "Ok",
                value: "action",
                className: "okay-btn"
              }
            },
          }).then((value) => {
            switch (value) {
              case "action":
                this.sponsorCategorySendToBackEnd_();
                // this.loadAllSponsorCategories();
                break;
              default:
                break;
            }
          });
          break;
          default:
            break;
    }

  };

  sponsorSendToBackEnd_ = () => {
    let req_obj = {
      sub_event_id: this.state.sub_event_id,
      sponsor_image: this.state.sponsor_image,
      sponsor_name: this.state.sponsor_name
    };

    this.props.spinnerHandler(true);

    let corporateId = this.props.usr_obj.corporates[0].corporateId;

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8"),
      "Content-Type": "application/json"
    };

    axios_event.post(apiConfig.SEND_SPONSOR({event_id:this.props.current_event.event_id, corporateId: corporateId}), req_obj, {headers: headers})
      .then(response => {
        if (response.data.success) {
          let msg = !this.state.sponsor_ok ? "saved" : "updated";
          common.warningAlert("Sponsor details " + msg + " successfully!", 0);
          this.cleanSponsorName();
          this.loadAllSponsorNames(this.state.sub_event_id);
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.sponsorSendToBackEnd_()
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  }

  sponsorCategorySendToBackEnd_ = () => {
    let req_obj = {
      subEventId: this.state.sub_event_id,
      sponsorship_category: this.state.sponsor_category
    };

    this.props.spinnerHandler(true);

    let corperateId = this.props.usr_obj.corporates[0].corporateId;

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8"),
      "Content-Type": "application/json"
    };
    axios_event.post(apiConfig.SEND_SPONSOR_CATEGORY({corporateId: corperateId}), req_obj, {headers: headers})
      .then(response => {
        if (response.data.success) {
          let msg = !this.state.sponsor_ok ? "saved" : "updated";
          common.warningAlert("Sponsor details " + msg + " successfully!", 0);
          // this.setState({
          //   sponsor_category_ok: true
          // });
          this.cleanCategoryName();
          this.loadAllSponsorCategories(this.state.sub_event_id);
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.sponsorCategorySendToBackEnd_()
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  }

  deleteSponsorDetails = (obj) => {
    swal({
      className: "swal-reception-number-check",
      text: "Are you sure to delete this sponsor?",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      buttons: {
        cancel: 'Cancel',
        dangerMode: {
          text: "Ok",
          value: "action",
          className: "okay-btn"
        }
      },
    }).then((value) => {
      switch (value) {
        case "action":
          this.deleteSponsorDetails_(obj);
          break;
        default:
          break;
      }
    });
  };

  deleteSponsorDetails_ = (obj) => {
      let  sub_event_id =this.state.sub_event_id;
      let s_id = obj.sub_event_category_sponsor_id;

    let corporateId = this.props.usr_obj.corporates[0].corporateId;

      const headers = {
        "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
      };

      axios_event.delete(apiConfig.DELETE_SPONSOR_DETAILS({sub_event_cat_id: s_id, corporateId: corporateId}), {headers: headers})
        .then(response => {
          if (response.data.success) {
            common.warningAlert("Deleted successfully", 0);

            this.loadAllSponsorDetails(sub_event_id);
          }else{
            common.warningAlert(response.data.message, 1)
          }
        })
        .catch(async error => {
          let result = await common.checkErrorResponse(error);
          if (result === 1) {
            this.deleteSponsorDetails_(obj)
          }
        })
        .finally(fin => {
          this.props.spinnerHandler(false);
        });
    }

  setInvitationImage = (image, convert) => {

    this.setState({
      invitation_image: convert
    });

  };
  // following codes use to manage invite participants - start
  setParticipantdetails = name => e => {
    let value = e.target.value;
    switch (name) {
      case "fname":
        this.setState({participant_fname: value});
        break;
      case "lname":
        this.setState({participant_lname: value});
        break;
      case "contact":
        let validateEmail = EmailValidator.validate(value);
        if (validateEmail) {
          this.setState({
            participant_contact: value,
            valid_participant_contact: true
          });
        } else {
          if (value.length >= 9) {

            let s = value.charAt(0);
            if (s === "+") {
              let val = value.substring(1);
              if (val.match(/^[0-9]+$/) != null) {
                this.setState({
                  participant_contact: value,
                  valid_participant_contact: true
                });
              } else {
                this.setState({
                  participant_contact: value,
                  valid_participant_contact: false
                });
              }
            } else {
              if (value.match(/^[0-9]+$/) != null) {
                this.setState({
                  participant_contact: value,
                  valid_participant_contact: true
                });
              } else {
                this.setState({
                  participant_contact: value,
                  valid_participant_contact: false
                });
              }
            }

          } else {
            this.setState({
              participant_contact: value,
              valid_participant_contact: false
            });
          }

        }
    }
  };

  //following methods use for csv upload for participants - end
  // };
  addToInvitationListValidate = () => {
    !this.state.invitation_ok ? common.notifyMessage("Please set invitation image and invitation text before set invitees") :
      this.state.participant_fname.trim() === '' ? common.notifyMessage("Please enter participant first name") :
        this.state.participant_lname.trim() === '' ? common.notifyMessage("Please enter participant last name") :
          this.state.participant_contact.trim() === '' ? common.notifyMessage("Please enter participant mobile or email") :
            !this.state.valid_participant_contact ? common.notifyMessage("Please enter valid participant mobile or email") :
              this.addToInvitationList();
  };
  addToInvitationList = () => {
    let arr = this.state.manualEnterdJson;
    arr.push({
      checked: true,
      contact: this.state.participant_contact,
      firstName: this.state.participant_fname,
      lastName: this.state.participant_lname,
    });

    this.setState({
      manualEnterdJson: arr,
      participant_fname: "",
      participant_lname: "",
      valid_participant_contact: false,
      participant_contact: "",
    });

  };

  closeErrorParticipantTable = () => {
    this.setState({
      errorjson: []
    });
  };
  makeParticipant1CheckORNot = (e, index) => {
    let arr = this.state.json;
    let v = arr[index];
    arr.splice(index, 1);
    let d = {
      checked: !v.checked,
      contact: v.contact,
      lastName: v.lastName,
      firstName: v.firstName,
    };
    arr.splice(index, 0, d);
    this.setState({
      json: arr
    });

  };

  makeParticipant2CheckORNot = (e, index) => {

    let arrx = this.state.manualEnterdJson;
    let vx = arrx[index];
    arrx.splice(index, 1);
    let dx = {
      checked: !vx.checked,
      contact: vx.contact,
      lastName: vx.lastName,
      firstName: vx.firstName,
    };
    arrx.splice(index, 0, dx);
    this.setState({
      manualEnterdJson: arrx
    });

  };

  onHandleChangeInvitationText = e => {
    let value = e.target.value;
    this.setState({
      invitation_text: value
    });
  };
  manageInvitationDetails = () => {
    this.state.invitation_image === '' ? common.notifyMessage("Please upload invitation image") :
      this.state.invitation_text === '' ? common.notifyMessage("Please enter invitation text") :
        this.sendBackEndToInvitationDetails();
  };

  sendBackEndToInvitationDetails = () => {
    swal({
      title: "Do you want to proceed",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      buttons: {
        cancel: 'Cancel',
        dangerMode: {
          text: "Yes",
          value: "action",
          className: "okay-btn"
        }
      },
    })
      .then((value) => {
        switch (value) {
          case "action":
            this.sendBackEndToInvitationDetails_();
            break;
          default:
        }
      });
  };
  sendBackEndToInvitationDetails_ = () => {
    let req_obj = {
      subEventId: this.state.sub_event_id,
      invitationImg: this.state.invitation_image,
      invitationText: this.state.invitation_text
    };

    this.props.spinnerHandler(true);

    let corperateId = this.props.usr_obj.corporates[0].corporateId;

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8"),
      "Content-Type": "application/json"
    };
    axios_event.patch(apiConfig.MANAGE_INVITATION_MAIL({corporateId: corperateId}), req_obj, {headers: headers})
      .then(response => {
        if (response.data.success) {
          let msg = !this.state.invitation_ok ? "saved" : "updated";
          common.warningAlert("Invitation details " + msg + " successfully!", 0);
          this.setState({
            invitation_ok: true
          });
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.sendBackEndToInvitationDetails_()
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  sendInvitations = () => {
    this.state.json.length === 0 && this.state.manualEnterdJson.length === 0 ? common.notifyMessage("Please set invitees") :
      this.sendInvitations_();
  };

  sendInvitations_ = () => {
    this.props.spinnerHandler(true);
    let invitees = [];

    this.state.json.map((res, index) => {
      invitees.push(res);
    });

    this.state.manualEnterdJson.map((res, index) => {
      invitees.push(res);
    });

    let obj = {
      sub_event_id: this.state.sub_event_id,
      participants: invitees
    };

    let corperateId = this.props.usr_obj.corporates[0].corporateId;

    this.props.spinnerHandler(true);

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8"),
      "Content-Type": "application/json"
    };
    axios_event.put(apiConfig.SEND_EVENT_INVITATION({corporateId: corperateId}), obj, {headers: headers})
      .then(response => {
        if (response.data.success) {
          common.warningAlert("All the participants are invited successfully!", 0);
          this.cleanInviteesJson();
        } else {
          this.setState({
            errorjson: response.data.errors
          });
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.sendInvitations_()
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };
  cleanInviteesJson = () => {
    this.setState({
      errorjson: [], json: [], manualEnterdJson: []
    });
  };
  getAllFeedbackQuestions = () => {

    // const headers = {
    //   "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    // };
    //
    // let coperateId = this.props.usr_obj.corporates[0].corporateId;
    // // Get all history
    // axios_event.get(apiConfig.GET_ALL_FEED_BACK_QUESTION({subEventId: this.state.sub_event_id), {headers: headers})
    //   .then(async response => {
    //     let _array = [];
    //     this.props.spinnerHandler(false);
    //
    //     if (response.data.success) {
    //       _array = response.data.
    //     }
    //
    //     this.setState({
    //       feedback_Question_Array: _array
    //     });
    //   })
    //
    //   .catch(async error => {
    //     let result = await common.checkErrorResponse(error);
    //     if (result === 1) {
    //       this.getAllHistory(startDate,endDate);
    //     } else {
    //       this.props.spinnerHandler(false)
    //     }
    //   })

  };
  // following codes use to manage invite participants - end
  onChangeFeedbackQuestions = name => e => {
    this.setState({
      feedback_Question: e.target.value
    });
  };

  addNewFeedbackQuestion = () => {
    this.state.feedback_Question.trim() === '' ? common.notifyMessage("Please enter a feedback question") :
      this.feedbackQuestionSendToBackEnd();
  };

  feedbackQuestionSendToBackEnd = () => {
    swal({
      className: "swal-reception-number-check",
      text: "Are you sure to add this question?",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      buttons: {
        cancel: 'Cancel',
        dangerMode: {
          text: "Ok",
          value: "action",
          className: "okay-btn"
        }
      },
    }).then((value) => {
      switch (value) {
        case "action":
          this.feedbackQuestionSendToBackEnd_();
          break;
        default:
          break;
      }
    });
  };


  feedbackQuestionSendToBackEnd_ = () => {

    let obj = {
      event_question_id: 0,
      sub_event_id: this.state.sub_event_id,
      question: this.state.feedback_Question,
      type: "RATE_QUESTION"
    };
    this.props.spinnerHandler(true);

    let corporateId = this.props.usr_obj.corporates[0].corporateId;

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    axios_event.post(apiConfig.MANAGE_FEED_BACK_QUESTION({corporateId: corporateId}), obj, {headers: headers})
      .then(response => {
        if (response.data.success) {
          // common.warningAlert(response.data.message, 0);
          common.warningAlert("Feedback quetion saved successfully", 0);
          // let q = response.data.eventQuestion === undefined? []: response.data.eventQuestion;
          // this.setState({
          //   feedback_Question_Array: q,
          //   feedback_Question: ""
          // });
          // if(q.length === 0) {
          this.loadFeedbackQuestions(this.state.sub_event_id);
          this.setState({
              feedback_Question: ""
          });
          // }
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.feedbackQuestionSendToBackEnd_()
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  deleteFeedbackQuestion = (index) => {
    swal({
      className: "swal-reception-number-check",
      text: "Are you sure to delete this question?",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      buttons: {
        cancel: 'Cancel',
        dangerMode: {
          text: "Ok",
          value: "action",
          className: "okay-btn"
        }
      },
    }).then((value) => {
      switch (value) {
        case "action":
          this.deleteFeedbackQuestion_(index);
          break;
        default:
          break;
      }
    });
  };

  deleteFeedbackQuestion_ = (index) => {
    let array = this.state.feedback_Question_Array;
    if (array[index] !== undefined) {
      let question_id = array[index].event_question_id;

      let corporateId = this.props.usr_obj.corporates[0].corporateId;

      const headers = {
        "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
      };

      axios_event.delete(apiConfig.MANAGE_GET_DELETE_FEED_BACK_QUESTION({id: question_id, corporateId: corporateId}), {headers: headers})
        .then(response => {
          if (response.data.success) {
            common.warningAlert("Deleted successfully", 0);
            // let q = response.data.eventQuestion === undefined? []: response.data.eventQuestion;
            // this.setState({
            //   feedback_Question_Array: q
            // });
            // if(q.length === 0) {
            //   this.loadFeedbackQuestions(sub_event_id);
            // }
            this.loadFeedbackQuestions(this.state.sub_event_id);
          }else{
            common.warningAlert(response.data.message, 1)
          }
        })
        .catch(async error => {
          let result = await common.checkErrorResponse(error);
          if (result === 1) {
            this.deleteFeedbackQuestion_(index)
          }
        })
        .finally(fin => {
          this.props.spinnerHandler(false);
        });
    }
  };

  updateSession = (value) => {

    this.setState({
      currentSession: value,
      isSessionOpen: true
    });

  };


  removeSession = (session_id) => {
    swal({
      className: "swal-reception-number-check",
      text: "Are you sure to delete this session?",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      buttons: {
        cancel: 'Cancel',
        dangerMode: {
          text: "Ok",
          value: "action",
          className: "okay-btn"
        }
      },
    }).then((value) => {
      switch (value) {
        case "action":
          this.removeSession_(session_id);
          break;
        default:
          break;
      }
    });
  };

  removeSession_ = (session_id) => {

    let corporateId = this.props.usr_obj.corporates[0].corporateId;

    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    axios_event.delete(apiConfig.DELETE_SESSION({sessionId: session_id, corporateId: corporateId}), {headers: headers})
      .then(response => {
        if (response.data.success) {
          common.warningAlert("Deleted successfully", 0);
          this.loadAllSessions(this.state.sub_event_id);
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.removeSession_(session_id)
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };
  closeSessionModal = () => {
    this.setState({isSessionOpen: false});
    if (this.state.sub_event_id !== 0) {
      this.loadAllSessions(this.state.sub_event_id);
    }
  };

  componentWillMount() {
    this.props.callAllEventCategories();
    if(this.props.current_event == null) {
      this.props.history.push("/eventtags/events");
      this.props.pgChangeHandler(1);
      return <Redirect to="/eventtags/events" />;
    }
  }


  componentWillUpdate() {
    if(this.props.current_event == null) {
      this.props.history.push("/eventtags/events");
      this.props.pgChangeHandler(1);
    }
  }



  componentDidMount() {
    if (!this.props.current_event || this.props.current_event === "" || this.props.current_event === null) {
      if(this.props.usr_obj.userRoles ==="CORP_ADMIN") {
        this.props.history.push(innerRoutes.cor_inner_route_allEvents);
      } else {
        this.props.history.push(innerRoutes.inner_route_allEvents);
      }
      this.props.pgChangeHandler(1);
      return;
    } else {
      if (this.props.current_event.has_sub_event) {
        this.setState({
          current_event: this.props.current_event
        });
        this.fillDataAsSubEvent(this.props.current_event, this.props.current_sub_event_id);
        this.props.pgChangeHandler(3);
      } else {
        this.setState({
          current_event: this.props.current_event
        });

        this.fillDataAsEvent(this.props.current_event, this.props.current_event.subEvent);
        this.props.pgChangeHandler(4);
      }

    }

    let corperateId = this.props.usr_obj.corporates[0].corporateId;
    this.loadAllSponsorCategories(corperateId);

    // window.onscroll = function() {
      if(window.pageYOffset >= 100) {
        $(".rapid-box-top-nav").css({"margin-top":"-66px", "position": "fixed", "z-index":"999"});
        // $(".rapid-box-top-nav").css({"margin-top":"-58px", "position": "fixed", "z-index":"999"});

        $(".publish-btn").css({"margin-top":"-44px", "position": "fixed", "z-index":"999"});
        // $(".publish-btn").css({"margin-top":"-43px", "position": "fixed", "z-index":"999"});


      } else {
        $(".rapid-box-top-nav").css({"margin-top":"-20px","position": "relative"});
        // $(".rapid-box-top-nav").css({"margin-top":"-14px","position": "relative"});

        $(".publish-btn").css({"margin-top":"0px","position": "fixed"});
        // $(".publish-btn").css({"margin-top":"-1px","position": "fixed"});
      }

    // };

  }

  changeSubEventStatus = () => {

    let msg = "publish";
    switch (this.state.subEventStatus) {
      case 'DRAFT': msg = "publish"; break;
      case 'PUBLISHED': msg = "unpublish"; break;
      case 'UNPUBLISHED': msg = "publish"; break;
      default: break;
    }

    let eventtype = "event";
    let eventtype2 = "Event";
    if (this.props.current_event.has_sub_event) {
      eventtype = "sub event";
      let eventtype2 = "Sub event";
    }

    swal({
      // className: "swal-reception-number-check",
      text: "Are you sure to " + msg + " " + eventtype + "?",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      buttons: {
        cancel: 'Cancel',
        dangerMode: {
          text: "Ok",
          value: "action",
          className: "okay-btn"
        }
      },
    }).then((value) => {
      switch (value) {
        case "action":
          this.changeSubEventStatus_(eventtype2);
          break;
        default:
          break;
      }
    });
  };

  changeSubEventStatus_ = (eventtype2) => {
    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    let corperateId = this.props.usr_obj.corporates[0].corporateId;
    axios_event.patch(apiConfig.CHANGE_SUB_EVENT_STATUS({corporateId: corperateId, subEventId: this.state.sub_event_id}), null, {headers: headers})
      .then(response => {
        if (response.data.success) {
          let msg = "publish";
          switch (response.data.content) {
            case 'UNPUBLISHED': msg = "unpublished"; break;
            case 'PUBLISHED': msg = "published"; break;
            default: break;
          }
          common.warningAlert(eventtype2 + " " + msg + " successfully!", 0);
          this.setState({
            subEventStatus: response.data.content
          });
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.changeSubEventStatus_(eventtype2)
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  componentDidUpdate() {
    window.onscroll = function() {
      if(window.pageYOffset >= 100) {
        $(".rapid-box-top-nav").css({"margin-top":"-66px", "position": "fixed", "z-index":"999"});
        // $(".rapid-box-top-nav").css({"margin-top":"-58px", "position": "fixed", "z-index":"999"});

        $(".publish-btn").css({"margin-top":"-44px", "position": "fixed", "z-index":"999"});
        // $(".publish-btn").css({"margin-top":"-43px", "position": "fixed", "z-index":"999"});
      } else {
        $(".rapid-box-top-nav").css({"margin-top":"-20px","position": "relative"});
        // $(".rapid-box-top-nav").css({"margin-top":"-14px","position": "relative"});

        $(".publish-btn").css({"margin-top":"0px","position": "fixed"});
        // $(".publish-btn").css({"margin-top":"-1px","position": "fixed"});
      }
    };
  }

  componentWillUnmount() {
    window.onscroll = null;
  }

  onChangeEventType = (e, { value }) => {
    if(value === "PHYSICAL") {
      this.setState({
        event_type: value,
      });
    } else {
      this.setState({
        event_type: value
      });
    }
  };

  //=nx

  clockVisibleChanger = (value) => {
    switch (value) {
      case "S":
        this.setState({
          s_visible: true,
          e_visible: false
        });
        break;
      case "E":
        this.setState({
          s_visible: false,
          e_visible: true
        });
        break;
      case "SV":
        this.setState({
          s_visible: false,
        });
        break;
      case "EV":
        this.setState({
          e_visible: false
        });
        break;
    }
  };


  getOnlineEventLink = () => {

    this.props.spinnerHandler(true);

    let corporateId = this.props.usr_obj.corporates[0].corporateId;

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8"),
      "Content-Type": "application/json"
    };

    //this.props.current_event.event_id
    axios_event.get(apiConfig.GET_ONLINE_EVENT_URL({subeventId: this.state.sub_event_id, corporateId: corporateId}), {headers: headers})
      .then(response => {
        if (response.data.success) {
          window.open(response.data.content.start_url, '_blank');
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          // this.getOnlineEventLink()
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  isAutoOrManualChangeHandler = () => {
    this.setState({isAutoOrManual: !this.state.isAutoOrManual})
  }

  render() {
    let {isAutoOrManual, is_question_form, subEventQuestions} = this.state;
    let isOldSubEvent = false;

    if(this.state.sub_event_id!==0 && this.state.real_et_for_btn_validation !=="") {
      let etr = new Date(this.state.real_et_for_btn_validation);
      if(new Date>etr) {
        isOldSubEvent = true;
      }
    }

    if(this.props.current_event == null) {
      this.props.history.push("/eventtags/events");
      this.props.pgChangeHandler(1);
      return <Redirect to="/eventtags/events" />;
    }

    let publish_btn_text = 'Publish';

    if(this.state.subEventStatus == 'DRAFT') {
      publish_btn_text = 'Publish';
    } else if (this.state.subEventStatus == 'PUBLISHED') {
      publish_btn_text = 'Unpublish';
    } else {
      publish_btn_text = 'Publish';
    }

    let eventCategories = this.props.event_categories;
    let cat_Options = [];
    eventCategories.map((cat, index) => {
      let obj = {
        key: cat.event_category_id,
        text: cat.title,
        value: cat.event_category_id
      }
      cat_Options.push(obj);
    });

    let sponsor_options = [];
    let sponsor_category_options =[];
    if(this.state.sponsor_name_array.length !== 0){
      this.state.sponsor_name_array.map((value, index) =>{
        sponsor_options.push({
          key: value.sponsor_Id,
          text: value.sponsor_name,
          value: value.sponsor_Id
        });
      });
    }
    if(this.state.sponsor_category_array.length !== 0){
      this.state.sponsor_category_array.map((value, index) =>{
        sponsor_category_options.push({
          key: value.sponsorship_category_id,
          text: value.category_name,
          value: value.sponsorship_category_id,
        })
      });
    }
    //load sponsor table
    let sponsor_row =[];
    if(this.state.sponsor_details){
      this.state.sponsor_details.map((value, index) =>{
        sponsor_row.push({
          category : value.sponsorship_category,
          name : value.sponsor_name,
          image:<img src={value.sponsor_img} width="45px"/>,
          action: <SementicBtn className="cus-btn" circular icon='trash alternate'
                  onClick={() => this.deleteSponsorDetails(value)}
          />
        })
      })
    }
    //load agenda table
    let row = [];
    if(this.state.sessions) {
      this.state.sessions.map((value, index) => {
        row.push({
          Name: value.name,
          Start_Time: timeutils.YYYYMMDDHHMMSSUTCToLocalDateTime(value.start_time),
          End_Time: timeutils.YYYYMMDDHHMMSSUTCToLocalDateTime(value.end_time),
          action: <div>
            <SementicBtn circular icon='edit' onClick={() => this.updateSession(value)}/>
            <SementicBtn className="cus-btn" circular icon='trash alternate'
                         onClick={() => this.removeSession(value.session_id)}/>
          </div>
        });
      });
    }

    let columns = [
      {
        label: 'Name',
        field: 'Name',
        sort: 'asc'
      },
      {
        label: 'Start Time',
        field: 'Start_Time',
        sort: 'asc'
      },
      {
        label: 'End Time',
        field: 'End_Time',
        sort: 'asc'
      },
      {
        label: 'Action',
        field: 'action',
        sort: 'asc'
      }

    ];
    let table_data = {columns:columns, rows:row};

    //load feedback quetion table
    let question_columns = [
      {
        label: 'Question',
        field: 'question',
        sort: 'asc'
      },
      {
        label: 'Action',
        field: 'action',
        sort: 'asc'
      }

    ];

    //load sponsor details table
    let sponsor_columns = [
      {
        label: 'Category',
        field: 'category',
        sort: 'asc'
      },
      {
        label: 'Name',
        field: 'name',
        sort: 'asc'
      },
      {
        label: 'Image',
        field: 'image',
        sort: 'asc'
      },
      {
        label: 'Action',
        field: 'action',
        sort: 'asc'
      }
    ]

    let question_row = [];
    let question_mobile_row = [];

    this.state.feedback_Question_Array.map((res, index) => {
      let obj = {
        question: res.question,
        action: <SementicBtn className="cus-btn" circular icon='trash alternate'
                             onClick={() => this.deleteFeedbackQuestion(index)}
        />
      };

      let feed_notifi = <div className={'text-left'} style={{paddingTop: '10px', fontWeight: 'bold', fontSize: '11px'}}>
                          {res.question}
                          <div style={{paddingTop: '5px'}}>
                            <Rating disabled={true} maxRating={5} defaultRating={Math.round(Math.random() * (5 - 1) + 1)} icon='star' size='huge'/>
                          </div>
                        </div>;

      question_row.push(obj);
      question_mobile_row.push(feed_notifi);
    });
    let question_table_data = {columns: question_columns, rows: question_row};


    //load csv and entered participant table
    let participant_row = [];

    this.state.json.map((value, index) => {
      participant_row.push({
        fname: value.firstName,
        lname: value.lastName,
        contact: value.contact,
        action: <div>
          <Checkbox style={{fontWeight: '600', color: 'rgba(72, 72, 72, 0.87)!important'}}
                    label=''
                    checked={value.checked}
                    onChange={e => this.makeParticipant1CheckORNot(e, index)}
          />
        </div>
      });

    });

    this.state.manualEnterdJson.map((value, index) => {
      participant_row.push({
        fname: value.firstName,
        lname: value.lastName,
        contact: value.contact,
        action: <div>
          <Checkbox style={{fontWeight: '600', color: 'rgba(72, 72, 72, 0.87)!important'}}
                    label=''
                    checked={value.checked}
                    onChange={e => this.makeParticipant2CheckORNot(e, index)}
          />
        </div>
      });

    });


    let participant_columns = [
      {
        label: 'First Name',
        field: 'fname',
        sort: 'asc'
      },
      {
        label: 'Last Name',
        field: 'lname',
        sort: 'asc'
      },
      {
        label: 'Mobile/Email',
        field: 'contact',
        sort: 'asc'
      },
      {
        label: 'Select',
        field: 'action',
        sort: 'asc'
      }

    ];
    let participant_table_data = {participant_columns, participant_row};

    //error messages load of participant load
    let error_participants_rows = [];

    let errorsInParticipants = this.state.errorjson;

    if(errorsInParticipants!==null && errorsInParticipants!==undefined) {
      this.state.errorjson.map((value, index) => {
        error_participants_rows.push({
          row: value.row,
          error: value.message,
        });
      });
    }
    let error_participants_columns = [
      {label: "Row", field: "row", sort: "asc"}, {label: "Error Messages", field: "error", sort: "asc"}
    ];


    //following codes are use to convert start time and end time into suitable objects which can set to date piker and
    // time picker
    //-------------------------------------------------------------------------
    let dateRange = null;
    let s_time = null;
    let e_time = null;
    let ss_date = null;
    let ee_date = null;

    if (this.state.start_date !== "") {

      let startdate = this.state.start_date;
      let enddate = this.state.end_date;
      dateRange = [moment(startdate), moment(enddate)];
      ss_date = moment(startdate);
      if(enddate) ee_date = moment(enddate);

    } else {
      ss_date = null;
      ee_date = null;
      dateRange = null;

    }

    if (this.state.start_time !== "") {

      let starttime = this.state.start_time;
      s_time = moment(starttime, "HH:mm:ss");

    } else {

      s_time = null;

    }

    if (this.state.end_time !== "") {

      let endtime = this.state.end_time;
      e_time = moment(endtime, "HH:mm:ss");

    } else {

      e_time = null;

    }

    // usher
    let usher_row = [];
    this.state.sub_event_volunteers.map((volunteer, index) => {
      let obj = {
        name: volunteer.fullName,
        email: (volunteer.email!==null & volunteer.email!==undefined & volunteer.email!=="")?volunteer.email:" - ",
        mobile: (volunteer.mobile!==null & volunteer.mobile!==undefined & volunteer.mobile!=="")?volunteer.mobile:" - ",
        role: volunteer.userRoles,
      };
      usher_row.push(obj);
    });
    let usher_table_data = {columns: usher_columns, rows: usher_row};

    //-------------------------------------------------------------------------
    //following part only show main event hasn't sub events
    let datetime = <div>
      {/*<Row>*/}
      {/*  <Col lg={12}>*/}
      {/*    <Lbl required>Event Date & Time</Lbl>*/}
      {/*    <RangePicker*/}
      {/*      key="1x"*/}
      {/*      size={"mini"}*/}
      {/*      // defaultValue={[moment().subtract(7, "days"), moment().subtract(0, "days")]}*/}
      {/*      disabledDate={disabledDate}*/}
      {/*      format="YYYY-MM-DD"*/}
      {/*      value={dateRange}*/}
      {/*      onChange={this.dateRangeOnChange}*/}
      {/*    />*/}
      {/*  </Col>*/}
      {/*</Row>*/}
      <Row className="TimePickerRow">
        <Col lg={5} className="TimePickerCol">
          <Lbl required>Event Start Date</Lbl>
          <DatePicker format="YYYY-MM-DD" value={ss_date}
                            disabledDate={disabledDate}
                      onChange={this.dateOnChangeStart}/>
        </Col>
        <Col lg={5} className="TimePickerCol">
          <Lbl required>Event Start Time</Lbl>
          <ModernTimePicker
            unic= {"S"}
            time={ this.state.start_time }
            change={ this.startTimeOnChange }
            visible= {this.state.s_visible}
            visi= { this.clockVisibleChanger } />
        </Col>
      </Row>
      <Row className="TimePickerRow">
        <Col lg={5} className="TimePickerCol">
          <Lbl required>Event End Date</Lbl>
          <DatePicker format="YYYY-MM-DD" value={ee_date}
                            disabledDate={disabledDate}
                      onChange={this.dateOnChangeEnd}/>
        </Col>
        <Col lg={5}>
          <Lbl required>Event End Time</Lbl>
          <ModernTimePicker
            unic= {"E"}
            time={ this.state.end_time }
            change={ this.endTimeOnChange }
            visible= {this.state.e_visible}
            visi= { this.clockVisibleChanger } />
        </Col>
      </Row>
    </div>;

    let organizer = <div>
      <hr/>
      <Row>
        <Col lg={6}>
          <Form>
            <Form.Group widths='equal'>
              <TxtLbl
                style={{marginTop: '10px'}}
                required
                tagText={"Event Organizer Name"}
                placeholder={"Show in the app"}
                value={this.state.organizer_name}
                onChange={this.onchangeHandler('organizer_name')}
              />
            </Form.Group>
          </Form>
        </Col>


        <Col lg="6">
          <Form>
            <Form.Group widths='equal'>
              <TxtLbl
                style={{marginTop: '10px'}}
                required
                tagText={"Event Organizer Mobile"}
                placeholder={"Show in the app"}
                value={this.state.organizer_mobile}
                onChange={this.onPhoneNumberChange}
              />
            </Form.Group>
          </Form>
        </Col>

        <Col lg={12} style={{marginTop: '10px'}}>
          <Form>
            <Form.Group widths='equal'>
              <TxtLbl
                required
                tagText={"Event Organizer Email"}
                placeholder={"Show in the app"}
                value={this.state.organizer_email}
                onChange={this.onchangeHandler('organizer_email')}
              />
            </Form.Group>
          </Form>
        </Col>

      </Row>

    </div>;

    return (

      <div className={"sub-event-wrapper"}>

        {
          this.state.isSessionOpen ?
            <Session etvalid={isOldSubEvent} subEventId={this.state.sub_event_id} subEventIdStart={this.state.start_date}
                     subEventIdEnd={this.state.end_date} currentSession={this.state.currentSession} subEventStartTime={this.state.start_time}
                     subEventEndTime={this.state.end_time}
                     closeModal={() => this.closeSessionModal()}/> : null
        }
        {
          this.state.isOpenAddVolunteers ?
            <AddVolunteers
              sub_event_id = { this.state.sub_event_id }
              closeModal = {() => this.closeAddVolunteersModal()}
            />
            :
            null
        }
        <Row>

          <Button
            disabled={!isOldSubEvent?this.state.sub_event_id !== 0? false: true:true}
            className={'publish-btn'}
            onClick={this.changeSubEventStatus}
          >{
            this.props.current_event.has_sub_event ? publish_btn_text + " Sub Event" : publish_btn_text + " Event"
          }
          {/*<Icon name='mobile-alt' />*/}
          </Button>

          <Col xs="12" lg={"12"} md={"12"} className={"padd_grap"}>
            <Card>

              <CardHeader>
                {
                  this.props.current_event ?
                    !this.props.current_event.has_sub_event || this.props.current_event.has_sub_event === '' ?
                      "Event Details" :
                      "Sub Event Details" :
                      ""
                }

                <div style={{display:"flex", float:"right"}}>

                  {
                    (this.state.broadcasting_url !== "" && this.state.broadcasting_url !== null && this.state.broadcasting_url !== undefined)?
                      // <Form.Group className={'text-right'} widths='equal'>
                      <Button
                        className="px-5"
                        // target={"_blank"} href={this.state.broadcasting_url}
                        onClick={this.getOnlineEventLink}
                        style={{marginLeft: "5px"}}
                      >
                        Start Online Event &nbsp;
                        <Icon name='video' style={{marginLeft: "2px", marginTop: "-4px"}}/>
                      </Button>
                      // </Form.Group>
                      :null
                  }

                  {/*{*/}
                  {/*  this.state.sub_event_id !== 0 && this.state.qr_code ?*/}
                  {/*    <Button style={{float: "right"}} onClick={()=>this.onViewQR(this.state.qr_code)}>View QR code</Button>: ""*/}
                  {/*}*/}
                  {
                  this.state.sub_event_id !== 0 && this.state.qr_code ?
                      <Button className={'viewQr-btn'} style={{float: "right"}} onClick={()=>this.onWEBViewQR(`${window.location.origin}${PUBLIC_WEB_SIGN_IN_PAGE}?e=${this.state.qr_code}`)}>View QR code</Button>: null
                  }

                </div>

                {
                  this.state.onViewQR ?
                  <MDBModal isOpen={true} toggle={()=>{}} size="md" top="60px">
                  <MDBModalHeader className={"title"} toggle={() => this.setState({onViewQR: false})}>
                    Event QR
                  </MDBModalHeader>
                  <MDBModalBody>
                    <Row style={{padding: '10px'}}>
                      <Col lg={12}>
                        <Form>
                          <Form.Group widths='equal'>
                            <img src={this.state.image} style={{border: "5px solid rgba(255, 0, 0, 0.5)"}}
                               className="event-image-qr"/>
                          </Form.Group>
                          <Col lg={"12"} className={"text-align-path"} style={{marginBottom: '5px'}}>
                            <Button
                              className="px-5"
                              target={"_blank"} href={this.state.image} download={true}
                            >Download</Button>
                          </Col>
                        </Form>
                      </Col>
                    </Row>
                  </MDBModalBody>
                </MDBModal> : ""
                }
              </CardHeader>
              <Collapse isOpen={true} id="collapseExample">
                <CardBody>

                  <Row style={{padding: '10px'}}>

                    <Col lg={6}>

                      <Form>

                        <Form.Group widths='equal'>
                          <TxtLbl
                            required
                            tagText={"Event Name"}
                            placeholder={"Event name"}
                            value={this.state.name}
                            onChange={this.onchangeHandler('name')}
                          />
                        </Form.Group>

                        <Form.Group widths='equal'>
                          <TxtAreaLbl
                            required
                            tagText={"Event Description"}
                            placeholder={"Event Description"}
                            value={this.state.description}
                            onChange={this.onchangeHandler('description')}
                          />
                        </Form.Group>

                        <Form.Group widths='equal'>
                          <DrpDwn
                            required
                            tagText={"Category"}
                            placeholder={"Select category"}
                            options={cat_Options}
                            value={this.state.catogary}
                            onChange={this.catogaryChangehandler}
                          />

                        </Form.Group>


                      </Form>

                      <Form>

                        <Row className="CheckBoxRow boldText">
                          <Col lg={5} className="TimePickerCol">
                            {
                              this.state.has_sub_event ?
                                <Checkbox style={{fontWeight: '600', color: 'rgba(72, 72, 72, 0.87)!important'}}
                                          disabled={this.state.current_event.privacy !== "PUBLIC" ? true : false}
                                          label='Make Private'
                                          checked={!(this.state.privacy === "PUBLIC")}
                                          onChange={this.privacyChangeHandler}
                                /> :
                                <Checkbox style={{fontWeight: '600', color: 'rgba(72, 72, 72, 0.87)!important'}}
                                          // disabled={this.state.current_event.privacy !== "PUBLIC" ? true : false}
                                          label='Make Private'
                                          checked={!(this.state.privacy === "PUBLIC")}
                                          onChange={this.privacyChangeHandler}
                                />
                            }
                          </Col>
                        </Row>
                        {!this.state.has_sub_event ?
                        <Row className="CheckBoxRow boldText">
                            <Col lg={12} className="TimePickerCol">
                              <Checkbox style={{fontWeight: '600', color: 'rgba(72, 72, 72, 0.87)!important'}}
                                        toggle
                                        label='Has Sub Events'
                                        disabled={true}
                                        defaultChecked={this.state.has_sub_event}
                                        onChange={this.hasSubEventChangeHandler}
                              />
                            </Col>
                        </Row>
                          : null
                        }
                          <Row className="CheckBoxRow boldText">
                            <Col lg={12} className="TimePickerCol">
                              <Checkbox style={{fontWeight: '600', color: 'rgba(72, 72, 72, 0.87)!important'}}
                                        toggle
                                        label='Has Question Form'
                                        defaultChecked={is_question_form} checked={is_question_form}
                                        onChange={()=>this.setState({is_question_form: !is_question_form})}
                              />
                            </Col>
                          </Row>

                        {/*{!this.state.has_sub_event && <Row className="CheckBoxRow boldText">
                          <Col lg={7} className="TimePickerCol">
                            <Checkbox style={{fontWeight: '600', color: 'rgba(72, 72, 72, 0.87)!important'}}
                                      toggle
                                      label='Required Manual Approve'
                                      defaultChecked={this.state.isAutoOrManual}
                                      onChange={this.isAutoOrManualChangeHandler}
                            />
                          </Col>
                        </Row>}*/}

                      </Form>

                      {datetime}

                      {/*Webinar dev part*/}

                      <Form style={{marginTop: "20px"}}>
                        <Form.Field>
                          <Lbl required>Event Type</Lbl>
                        </Form.Field>

                        <div style={{display: "flex"}}>
                          <Form.Field className={"event-type-radio-style"}>
                            <Radio
                              label='Physical'
                              name='radioGroup'
                              value='PHYSICAL'
                              checked={this.state.event_type === 'PHYSICAL'}
                              onChange={this.onChangeEventType}
                            />
                          </Form.Field>
                          <Form.Field className={"event-type-radio-style"}>
                            <Radio
                              label='Online'
                              name='radioGroup'
                              value='ONLINE'
                              checked={this.state.event_type === 'ONLINE'}
                              onChange={this.onChangeEventType}
                            />
                          </Form.Field>
                          <Form.Field className={"event-type-radio-style"}>
                            <Radio
                              label='Both(Physical + Online)'
                              name='radioGroup'
                              value='BOTH'
                              checked={this.state.event_type === 'BOTH'}
                              onChange={this.onChangeEventType}
                            />
                          </Form.Field>
                        </div>

                        <Row className="CheckBoxRow boldText">
                          <Col lg={7} className="TimePickerCol">
                            <Checkbox style={{fontWeight: '600', color: 'rgba(72, 72, 72, 0.87)!important'}}
                                      toggle
                                      label='Required Manual Approve'
                                      checked={isAutoOrManual}
                                      onChange={this.isAutoOrManualChangeHandler}
                            />
                          </Col>
                        </Row>

                        {
                          this.state.event_type!=="PHYSICAL"?
                            <div style={{marginTop: "10px"}}>
                              {/*<Col lg={"12"} className={"text-align-path"}>*/}
                              {/*  <Button*/}
                              {/*    className="px-5"*/}
                              {/*    target={"_blank"} href={this.state.image} download={true}*/}
                              {/*  >Download</Button>*/}
                              {/*</Col>*/}

                              <Form.Group widths='equal'>
                                <TxtAreaLbl
                                  tagText={"Instructions to join the meeting"}
                                  placeholder={"Instructions to join the meeting"}
                                  value={this.state.broadcasting_instructions}
                                  onChange={this.onchangeHandler('bci')}
                                />
                              </Form.Group>
                            </div>
                            :null
                        }

                      </Form>

                      {
                        this.state.event_type!=="ONLINE"?
                          <Form style={{marginTop: "20px"}}>
                            <Form.Group widths='equal'>
                              <TxtLbl
                                required
                                tagText={"Address"}
                                placeholder={"Address Line 1"}
                                value={this.state.addressLine1}
                                onChange={this.setAddressOfLocation('address1')}
                              />
                            </Form.Group>
                            <Form.Group widths='equal'>
                              <TxtLbl
                                required
                                // tagText={"Address"}
                                placeholder={"Address Line 2"}
                                value={this.state.addressLine2}
                                onChange={this.setAddressOfLocation('address2')}
                              />
                            </Form.Group>
                            <Form.Group widths='equal'>
                              <TxtLbl
                                required
                                // tagText={"Address"}
                                placeholder={"Address Line 3"}
                                value={this.state.addressLine3}
                                onChange={this.setAddressOfLocation('address3')}
                              />
                            </Form.Group>
                          </Form>
                          :null
                      }


                      {/*{*/}
                        {/*!this.state.has_sub_event ?*/}
                          {/*<Col xs="12" lg={"12"} md={"12"} className="" style={{padding: "0px", marginTop: "10px"}}>*/}

                            {/*<Lbl marginTop={"0px"} required>Location</Lbl>*/}

                            {/*<div style={{padding: "0px", width: "100%"}}>*/}
                              {/*<div>*/}
                                {/*<GoogleAutoComplete setLocation={this.setLocation} location={this.state.location}/>*/}
                              {/*</div>*/}
                              {/*<div className={"map-wrapper"} style={{padding: "0px", width: "100%"}}>*/}
                                {/*{!this.state.delay ? <GoogleDirectionMap markers={this.state.location}*/}
                                                                         {/*updateMapLocation={this.updateMapLocation}/> : null}*/}
                              {/*</div>*/}
                            {/*</div>*/}


                          {/*</Col> */}
                          {/**/}
                          {/**/}
                          {/*: ""*/}
                      {/*}*/}


                    </Col>

                    <Col lg={6}>

                      <Row>
                        <Col xs="12" lg={"12"} md={"12"} className="textAlignCenter">
                          <Lbl required>Event Icon</Lbl>
                          <CropImageUploader propName="SubEvent" image={this.state.icon} getImage={this.setIcon}/>
                        </Col>

                        <Col xs="12" lg={"12"} md={"12"} className="textAlignCenter">
                          <Lbl>Event Brochure</Lbl>
                          <FileUploader
                            fileStyle={"file1"}
                            key={'1'}
                            getFile={this.setBrochure}
                            preview={this.state.brochureName}
                            blink={this.state.brochureLink}
                            onFilesError={this.onFilesError}
                          />
                        </Col>
                        {
                          !this.state.has_sub_event ?
                            organizer : ""
                        }


                      </Row>

                    </Col>

                  </Row>


                  {
                    this.state.event_type!=="ONLINE"?

                      <Row>
                        <Col className={"paddingForMap"} lg={"12"}>

                          <Lbl marginTop={"0px"} required>Location</Lbl>(Search or drag map for set location)

                          <div style={{padding: "0px", width: "100%"}}>
                            <div>
                              <GoogleAutoComplete setLocation={this.setLocation} location={this.state.location}/>
                            </div>
                            <div className={"map-wrapper"} style={{padding: "0px", width: "100%"}}>
                              {!this.state.delay ? <GoogleDirectionMap markers={this.state.location}
                                                                       updateMapLocation={this.updateMapLocation}/> : null}
                            </div>
                          </div>

                        </Col>
                      </Row>

                      : null
                  }
                  <Row>

                    {this.state.sub_event_id !== 0 ?
                      <Col lg={"12"} className={"text-align-path text-right"} style={{marginBottom: '5px'}}>
                        <Button
                          className="px-5"
                          disabled={isOldSubEvent}
                          onClick={() => this.validateSubEvent(2)}
                        >Save Changes</Button>
                      </Col>
                      :
                      this.props.current_event.has_sub_event ?
                      <Col lg={"12"} className={"text-align-path text-right"} style={{marginBottom: '5px'}}>
                        <Button
                          className="px-5"
                          onClick={() => this.validateSubEvent(1)}
                        >Create</Button>
                      </Col>
                        :
                        <Col lg={"12"} className={"text-align-path text-right"} style={{marginBottom: '5px'}}>
                          <Button
                            className="px-5"
                            onClick={() => this.validateSubEvent(1)}
                          >Save Changes</Button>
                        </Col>
                    }

                  </Row>

                </CardBody>
              </Collapse>
            </Card>
          </Col>

        </Row>
        {is_question_form && this.state.sub_event_id ? <QuestionForm subEventQuestions={subEventQuestions} subEventId={this.state.sub_event_id} /> :null}
        <Row>
          <Col xs="12" lg={"12"} md={"12"} className={"padd_grap"}>
            <Card>
              <CardHeader>
                Agenda
              </CardHeader>
              <Collapse isOpen={true} id="collapseExample">
                <CardBody>

                  <Row style={{padding: '10px'}}>

                    <Col lg={"12"} className={"text-align-path"} style={{marginBottom: '5px', textAlign: 'end'}}>
                      <Button
                        className="px-5"
                        disabled={!isOldSubEvent?this.state.sub_event_id !== 0 ? false : true:true}
                        onClick={this.changeSessionModal}
                      >
                        <i aria-hidden="true" className="plus icon"></i>
                        New Session
                      </Button>
                    </Col>

                  </Row>

                  <Row style={{padding: '10px'}}>

                    <Col lg={12}>
                      {
                        this.state.sessions.length !== 0 ?
                          <MDBDataTable
                            id={"history-table"}
                            exportToCSV={true}
                            searching={false}
                            searchLabel={"Search visitor"}
                            responsive
                            responsiveSm
                            responsiveMd
                            responsiveLg
                            responsiveXl
                            // striped={true}
                            bordered
                            hover
                            data={table_data}/>
                          : <div className={"align-center fully-width"}>
                            <Empty description={"Records not found"} className={"empty-icon"}/>
                          </div>
                      }
                    </Col>
                  </Row>

                </CardBody>
              </Collapse>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col xs="12" lg={"12"} md={"12"} className={"padd_grap"}>
            <Card>
              <CardHeader>
                Sponsorship
              </CardHeader>
              <Collapse isOpen={true} id="collapseExample">
                <CardBody>
                <Row>
                <Col lg={6}>
                      <Form>
                        <Form.Group widths='equal'>
                          <DrpDwn
                            // required
                            tagText={ <Row className={"rw"}>
                            <Label className={"sponsor-h "}>Sponsor Name
                            <Label style={{float:"right"}}className="add-new-btn" onClick={this.onAddSponsorName}>Add New</Label></Label>
                          </Row>}
                            placeholder={"Select sponsor"}
                            options={sponsor_options}
                            value={this.state.selected_sponsor}
                            onChange={this.sponsorNameChangehandler}
                          />

                        </Form.Group>
                      </Form>
                    </Col>

                    {
                      this.state.onAddSponsorName ?
                        <MDBModal isOpen={true} toggle={()=>{}} size="md" top={"30px"}>
                          <MDBModalHeader className={"title"} toggle={() => this.setState({onAddSponsorName: false})}>
                            Add New Sponsor
                          </MDBModalHeader>
                          <MDBModalBody>
                            <Row style={{padding: '10px'}}>
                              <Col lg={6}>
                                <Form>
                                  <Form.Group widths='equal'>
                                    <TxtLbl
                                      tagText={"Sponsor Name"}
                                      placeholder={"Sponsor Name"}
                                      value={this.state.sponsor_name}
                                      onChange={this.setSponsorDetails('sponsorname')}
                                    />
                                  </Form.Group>
                                </Form>
                              </Col>
                              <Col xs="12" lg={"6"} md={"4"} className="textAlignCenter">
                              <Lbl required>Sponsor Image</Lbl>
                              <CropImageUploader propName="Sponsor" image={this.state.sponsor_image}
                                                getImage={this.setSponsorImage}/>

                            </Col>
                            <Col lg={"12"} className={"text-align-path"} style={{marginBottom: '5px'}}>
                              <Button
                                className="px-5"
                                disabled={isOldSubEvent}
                                onClick={this.manageSponsor}
                              >Add Sponsor</Button>
                            </Col>
                            </Row>
                          </MDBModalBody>
                          </MDBModal>
                        : null
                    }

                    <Col lg="6">
                      <Form>
                        <Form.Group widths='equal'>
                          <DrpDwn
                            // style={{marginTop: '10px'}}
                            // required
                            tagText={ <Row className={"rw"}>
                              <Label className={"sponsor-h "} required>Sponsorship Category
                              <Label className="add-new-btn" onClick={this.onAddSponsorCategory}>Add New</Label></Label>
                            </Row>}
                            placeholder={"Select Sponsorship Category"}
                            options={sponsor_category_options}
                            value={this.state.selected_category}
                            onChange={this.sponsorCategoryChangehandler}
                          />

                        </Form.Group>
                      </Form>
                    </Col>
                    {
                      this.state.onAddSponsorCategory ?
                      <MDBModal isOpen={true} toggle={()=>{}} size="md" top="60px">
                          <MDBModalHeader className={"title"} toggle={() => this.setState({onAddSponsorCategory: false})}>
                            Add New Sponsor Category
                          </MDBModalHeader>
                          <MDBModalBody>
                            <Row style={{padding: '10px'}}>
                              <Col lg={12}>
                                <Form>
                                  <Form.Group widths='equal'>
                                    <TxtLbl
                                      tagText={"Sponsorship Category"}
                                      placeholder={"Sponsorship Category"}
                                      value={this.state.sponsor_category}
                                      onChange={this.setSponsorDetails('sponsorcategory')}
                                    />
                                  </Form.Group>
                                  <Col lg={"12"} className={"text-align-path"} style={{marginBottom: '5px'}}>
                                    <Button
                                      className="px-5"
                                      disabled={isOldSubEvent}
                                      onClick={this.manageSponsorCategory}
                                    >Add Sponsorship Category</Button>
                                  </Col>
                                </Form>
                              </Col>
                            </Row>
                          </MDBModalBody>
                        </MDBModal> : null
                    }
                </Row>
                <Row>
                <Col lg={"12"} className={"text-align-path"} style={{marginBottom: '5px'}}>
                        <Button
                          className="px-5"
                          style={{marginTop:"20px"}}
                          disabled={!isOldSubEvent?this.state.sub_event_id !== 0 ? false : true: true}
                          onClick={this.getAllSponsorDetails__}
                        >Save Sponsor</Button>
                      </Col>
                </Row>
                {
                  this.state.sponsor_details.length !== 0  ?
                  <MDBDataTable
                    searching={false}
                    displayEntries={true}
                  // paging={false}
                  // entries={0}
                    responsive
                    responsiveSm
                    responsiveMd
                    responsiveLg
                    responsiveXl
                    striped
                    bordered
                    hover
                    columns={sponsor_columns}
                    rows={sponsor_row}
                /> : <div className={"align-center fully-width"}>
                      <Empty description={"Records not found"} className={"empty-icon"}/>
                    </div>
                }
                </CardBody>
              </Collapse>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col xs="12" lg={"12"} md={"12"} className={"padd_grap"}>
            <Card>
              <CardHeader>
                Volunteers
              </CardHeader>
              <Collapse isOpen={true} id="collapseExample">
                <CardBody>
                  <Row>
                    <Col lg="12">
                      <Row>
                        <Col lg={'12'} className={"text-align-path"} style={{marginBottom: '5px', textAlign: 'end'}}>
                          <Button
                            // disabled={!isOldSubEvent?this.state.sub_event_id !== 0 ? false : true:true}
                            className="px-5"
                            disabled={!isOldSubEvent?this.state.sub_event_id !== 0 ? false : true:true}
                            onClick={this.changeAddVolunteersModal}
                          >

                            {
                              this.state.sub_event_volunteers.length>0?
                                <span>
                                  <i aria-hidden="true" className="edit icon"></i>
                                  Edit Volunteers
                                </span>
                                :
                                <span>
                                  <i aria-hidden="true" className="plus icon"></i>
                                  New Volunteers
                                </span>
                            }

                          </Button>

                        </Col>
                      </Row>
                    </Col>
                    <Col lg={12} className={'mt-5'}>
                      {
                        this.state.sub_event_volunteers.length>0?
                          <MDBDataTable
                            searching={true}
                            displayEntries={false}
                            responsive
                            responsiveSm
                            responsiveMd
                            responsiveLg
                            responsiveXl
                            bordered
                            hover
                            data={usher_table_data}
                          />
                          :
                          <div className={"align-center fully-width"}>
                            <Empty description={"Records not found"} className={"empty-icon"}/>
                          </div>
                      }

                    </Col>
                  </Row>
                </CardBody>
              </Collapse>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col xs="12" lg={"12"} md={"12"} className={"padd_grap"}>
            <Card>
              <CardHeader>
                Invitations
              </CardHeader>
              <Collapse isOpen={true} id="collapseExample">
                <CardBody>

                  <Row style={{padding: '10px'}}>

                    <Col lg={12}>


                      <Row>
                        <Col xs="12" lg={"4"} md={"4"} className="textAlignCenter">
                          <Lbl required>Invitation Image</Lbl>

                          {/*<CropImageUploader image={this.state.icon} getImage={this.setIcon}/>*/}
                          <CropImageUploader propName="Invitation" image={this.state.invitation_image}
                                             getImage={this.setInvitationImage}/>

                        </Col>

                        <Col xs="12" lg={"8"} md={"8"}>
                          <Form>
                            <Form.Group widths='equal' className={'textAreaSize'}>
                              <TxtAreaLbl
                                required
                                tagText={"Invitation text"}
                                placeholder={"Invitation text"}
                                value={this.state.invitation_text}
                                onChange={this.onHandleChangeInvitationText}
                              />
                            </Form.Group>
                          </Form>
                          <div className={'text-center'}>
                            <Button
                              disabled={!isOldSubEvent?this.state.sub_event_id !== 0 ? false : true:true}
                              className="px-5"
                              onClick={this.manageInvitationDetails}
                            >
                              {
                                !this.state.invitation_ok ? "Save" : "Update"
                              }
                            </Button>
                          </div>

                        </Col>

                      </Row>
                      <hr/>
                      <Form>

                        <Row>

                          <Col lg={12} style={{textAlign: 'center'}}>
                            <p className={'display-inline-p'}>(Download the </p>
                            <a href={csvFormat} className={'display-inline-p'}>participant_list_format.csv<i
                              aria-hidden="true" className="download icon"></i></a>
                            <p>. Modify the contents and upload)</p>
                          </Col>

                          <Col lg={3} style={{textAlign: 'center'}}></Col>
                          <Col lg={6} style={{textAlign: 'center'}}>
                            {
                              this.state.subEventStatus === "UNPUBLISHED" ?
                                <Message color='red' style={{marginTop: "30px"}}><Icon name={"exclamation triangle"}/>You can't upload participants
                                  because event is currently un-published</Message> : ""
                            }

                            <Form.Group widths='equal'
                                        style={{display: "inherit", marginTop: "32px", marginBottom: "32px"}}>

                              <div className="pos" style={{display: "inline-flex"}}>
                                <Files
                                  className='files-dropzonex'
                                  onChange={this.onFilesChange("file")}
                                  accepts={["text/csv", ".csv"]}
                                  multiple={false}
                                  maxFileSize={10000000}
                                  minFileSize={0}
                                  clickable
                                >
                                  <button
                                    disabled={!isOldSubEvent?this.state.subEventStatus === "UNPUBLISHED" || this.state.sub_event_id === 0  ? true : !this.state.invitation_ok :true}
                                    className={"file-uploader"}>Choose CSV file&nbsp;&nbsp;
                                    <Icon name={"upload"}/>
                                  </button>
                                </Files>

                              </div>

                            </Form.Group>

                          </Col>
                          <Col lg={3} style={{textAlign: 'center'}}></Col>
                          {/*<Col lg={2}>*/}

                          {/*OR*/}

                          {/*</Col>*/}
                          <Col lg={3} style={{textAlign: 'center'}}></Col>
                          <Col lg={6}>

                            <Row>

                              <Col lg={6}>
                                <Form.Group widths='equal'>
                                  <TxtLbl
                                    tagText={"Participant First Name"}
                                    placeholder={"Participant First Name"}
                                    value={this.state.participant_fname}
                                    onChange={this.setParticipantdetails('fname')}
                                  />
                                </Form.Group>
                              </Col>

                              <Col log={6}>
                                <Form.Group widths='equal'>
                                  <TxtLbl
                                    tagText={"Participant Last Name"}
                                    placeholder={"Participant Last Name"}
                                    value={this.state.participant_lname}
                                    onChange={this.setParticipantdetails('lname')}
                                  />
                                </Form.Group>
                              </Col>

                              <Col lg="12">
                                <Form.Group widths='equal'>
                                  <TxtLbl
                                    tagText={"Participant Mobile / Email"}
                                    placeholder={"Participant Mobile / Email"}
                                    value={this.state.participant_contact}
                                    onChange={this.setParticipantdetails('contact')}
                                  />
                                </Form.Group>
                              </Col>
                            </Row>

                            <Row>

                              <Col lg={"12"} className={"text-align-path"}
                                   style={{marginTop: '15px', marginBottom: '5px', textAlign: 'end'}}>

                                <Button
                                  disabled={!isOldSubEvent?this.state.subEventStatus === "UNPUBLISHED" || this.state.sub_event_id === 0  ? true : !this.state.invitation_ok:true}
                                  className="px-5"
                                  onClick={this.addToInvitationListValidate}
                                >Add to Invitation List</Button>

                              </Col>

                            </Row>


                          </Col>
                          <Col lg={3} style={{textAlign: 'center'}}></Col>

                        </Row>

                      </Form>

                      {this.state.errorjson.length !== 0 ?
                        <div className={"error_paritcipant_card_body"}>

                          <div style={{width: "100%", textAlign: "end"}}>
                            <button style={{background: "none", border: "none"}}
                                    onClick={this.closeErrorParticipantTable}>
                              <i className="close icon"></i>
                            </button>
                          </div>

                          <Row className={"none-margin"}>
                            <Col xs={12} className={"error_paritcipant_text"}>
                              Errors at some rows
                            </Col>
                            <Col xs={12} className={"none-padding"}>
                              <MDBDataTable
                                searching={false}
                                displayEntries={true}
                                // paging={false}
                                // entries={0}
                                responsive
                                responsiveSm
                                responsiveMd
                                responsiveLg
                                responsiveXl
                                striped
                                bordered
                                hover
                                columns={error_participants_columns}
                                rows={error_participants_rows}
                              />
                            </Col>
                          </Row>
                        </div> : null
                      }
                      {
                        participant_row.length !== 0 ?
                          <MDBDataTable
                            searching={false}
                            displayEntries={true}
                            // paging={false}
                            // entries={0}
                            responsive
                            responsiveSm
                            responsiveMd
                            responsiveLg
                            responsiveXl
                            striped
                            bordered
                            hover
                            columns={participant_columns}
                            rows={participant_row}
                          />
                          : null
                      }

                      {
                        participant_row.length !== 0 ? <Row>

                          <Col lg={"12"} className={"text-align-path"}
                               style={{marginTop: '15px', marginBottom: '5px', textAlign: 'center'}}>

                            <Button
                              className="px-5"
                              disabled={isOldSubEvent}
                              onClick={this.sendInvitations}
                            >Send Invitations</Button>

                          </Col>

                        </Row> : null
                      }
                    </Col>

                  </Row>

                </CardBody>
              </Collapse>
            </Card>
          </Col>
        </Row>

        <Row>


          <Col xs="12" lg={"12"} md={"12"} className={"padd_grap"}>
            <Card>
              <CardHeader>
                Feedback Questions
              </CardHeader>
              <Collapse isOpen={true} id="collapseExample">
                <CardBody>

                  <Row style={{padding: '10px'}}>

                    <Col lg={"6"}>

                      <Form>

                        <Form.Group widths='equal'>
                          <TxtLbl
                            tagText={"Question"}
                            placeholder={"Question"}
                            value={this.state.feedback_Question}
                            onChange={this.onChangeFeedbackQuestions('feedback_questions')}
                          />
                        </Form.Group>

                      </Form>

                      <div className={'text-right'}>
                        <Button
                          disabled={!isOldSubEvent?this.state.sub_event_id !== 0 ? false : true:true}
                          className="px-5"
                          onClick={this.addNewFeedbackQuestion}
                        >Add</Button>
                      </div>

                      {
                        this.state.feedback_Question_Array.length !== 0 ?
                          <MDBDataTable
                            searching={true}
                            displayEntries={true}
                            responsive
                            responsiveSm
                            responsiveMd
                            responsiveLg
                            responsiveXl
                            bordered
                            hover
                            data={question_table_data}
                          />
                          : <div className={"align-center fully-width"}>
                            <Empty description={"Records not found"} className={"empty-icon"}/>
                          </div>
                      }

                    </Col>
                    <Col lg={"6"} md={"12"} sm={"12"} className={'text-center'}>
                      <div className={'feedback-quetion-mobile text-center'}>
                        <div className={'feedback-quetion-mobile-in'}>

                          <div className="grid-container-mobile-head">
                            <div style={{
                              fontSize: '12px',
                              textAlign: 'left'
                            }}>{new Date().getHours() + " : " + new Date().getMinutes()}</div>
                            <div style={{textAlign: 'center'}}></div>
                            <div style={{textAlign: 'end'}}>
                              <i aria-hidden="true" style={{fontSize: '12px'}} className="signal circle icon"></i>
                              <i aria-hidden="true" style={{fontSize: '12px'}} className="wifi circle icon"></i>
                              <i aria-hidden="true" style={{fontSize: '12px'}} className="battery full icon"></i>
                            </div>
                          </div>
                          <div style={{fontSize: '16px', fontWeight: 'bold', textAlign: 'left', paddingLeft: '10px'}}>
                            <i aria-hidden="true" style={{fontSize: '12px', color: '#00bcd4'}}
                               className="chevron square left icon"></i>Feedback
                          </div>

                          <div style={{marginLeft: '8px', overflowY: 'auto', height: '305px'}}>

                            {
                              question_mobile_row.length !== 0 ? question_mobile_row :
                                <div className={"align-center fully-width"}>
                                  <Empty description={"Records not found"} className={"empty-icon"}/>
                                </div>
                            }

                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>

                </CardBody>
              </Collapse>
            </Card>
          </Col>
        </Row>


      </div>

    );

  }

}

function readFile(file) {
  return new Promise(resolve => {
    const reader = new FileReader();
    reader.addEventListener("load", () => resolve(reader.result), false);
    reader.readAsDataURL(file);
  });
}
//load usher table
let usher_columns = [
  {
    label: 'Name',
    field: 'name',
    sort: 'asc'
  },
  {
    label: 'Email',
    field: 'email',
    sort: 'asc'
  },
  {
    label: 'Mobile',
    field: 'mobile',
    sort: 'asc'
  },
  {
    label: 'Role',
    field: 'role',
    sort: 'asc'
  }
];
const mapStateToProps = (state) => ({
  // pg: state.eventReducer.pg,
  current_event: state.eventReducer.current_event,
  current_sub_events: state.eventReducer.current_sub_events,
  current_sub_event_id: state.eventReducer.current_sub_event_id,
  // table_data: state.subEventReducer.Sub_Event_Table_data,
  // usr obj
  usr_obj: state.userReducer.user,
  event_categories: state.eventReducer.all_Event_Catogaries,
  sponsor_obj: state.notificationReducer.allsponsorobj
});

const mapDispatchToProps = (dispatch) => {
  return {
    callAllEventCategories: () => dispatch(actionCreator.callAllEventCatogaries()),
    pgChangeHandler: (data) => dispatch(actionCreator.stepActivateionEventHandler(data)),
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
